var map = {
	"./": 84058,
	"./_lib/buildFormatLongFn": 71645,
	"./_lib/buildFormatLongFn/": 71645,
	"./_lib/buildFormatLongFn/index": 71645,
	"./_lib/buildFormatLongFn/index.js": 71645,
	"./_lib/buildLocalizeFn": 89909,
	"./_lib/buildLocalizeFn/": 89909,
	"./_lib/buildLocalizeFn/index": 89909,
	"./_lib/buildLocalizeFn/index.js": 89909,
	"./_lib/buildMatchFn": 37407,
	"./_lib/buildMatchFn/": 37407,
	"./_lib/buildMatchFn/index": 37407,
	"./_lib/buildMatchFn/index.js": 37407,
	"./_lib/buildMatchPatternFn": 32515,
	"./_lib/buildMatchPatternFn/": 32515,
	"./_lib/buildMatchPatternFn/index": 32515,
	"./_lib/buildMatchPatternFn/index.js": 32515,
	"./af": 51770,
	"./af/": 51770,
	"./af/_lib/formatDistance": 19572,
	"./af/_lib/formatDistance/": 19572,
	"./af/_lib/formatDistance/index": 19572,
	"./af/_lib/formatDistance/index.js": 19572,
	"./af/_lib/formatLong": 12381,
	"./af/_lib/formatLong/": 12381,
	"./af/_lib/formatLong/index": 12381,
	"./af/_lib/formatLong/index.js": 12381,
	"./af/_lib/formatRelative": 36406,
	"./af/_lib/formatRelative/": 36406,
	"./af/_lib/formatRelative/index": 36406,
	"./af/_lib/formatRelative/index.js": 36406,
	"./af/_lib/localize": 92921,
	"./af/_lib/localize/": 92921,
	"./af/_lib/localize/index": 92921,
	"./af/_lib/localize/index.js": 92921,
	"./af/_lib/match": 39152,
	"./af/_lib/match/": 39152,
	"./af/_lib/match/index": 39152,
	"./af/_lib/match/index.js": 39152,
	"./af/index": 51556,
	"./af/index.d.ts": 41463,
	"./af/index.js": 51556,
	"./af/index.js.flow": 66053,
	"./af/package": 98439,
	"./af/package.json": 98439,
	"./ar": 89959,
	"./ar-DZ": 21757,
	"./ar-DZ/": 21757,
	"./ar-DZ/_lib/formatDistance": 84895,
	"./ar-DZ/_lib/formatDistance/": 84895,
	"./ar-DZ/_lib/formatDistance/index": 84895,
	"./ar-DZ/_lib/formatDistance/index.js": 84895,
	"./ar-DZ/_lib/formatLong": 96502,
	"./ar-DZ/_lib/formatLong/": 96502,
	"./ar-DZ/_lib/formatLong/index": 96502,
	"./ar-DZ/_lib/formatLong/index.js": 96502,
	"./ar-DZ/_lib/formatRelative": 42532,
	"./ar-DZ/_lib/formatRelative/": 42532,
	"./ar-DZ/_lib/formatRelative/index": 42532,
	"./ar-DZ/_lib/formatRelative/index.js": 42532,
	"./ar-DZ/_lib/localize": 46563,
	"./ar-DZ/_lib/localize/": 46563,
	"./ar-DZ/_lib/localize/index": 46563,
	"./ar-DZ/_lib/localize/index.js": 46563,
	"./ar-DZ/_lib/match": 29249,
	"./ar-DZ/_lib/match/": 29249,
	"./ar-DZ/_lib/match/index": 29249,
	"./ar-DZ/_lib/match/index.js": 29249,
	"./ar-DZ/index": 4812,
	"./ar-DZ/index.d.ts": 67209,
	"./ar-DZ/index.js": 4812,
	"./ar-DZ/index.js.flow": 50155,
	"./ar-DZ/package": 46634,
	"./ar-DZ/package.json": 46634,
	"./ar-EG": 15691,
	"./ar-EG/": 15691,
	"./ar-EG/_lib/formatDistance": 21227,
	"./ar-EG/_lib/formatDistance/": 21227,
	"./ar-EG/_lib/formatDistance/index": 21227,
	"./ar-EG/_lib/formatDistance/index.js": 21227,
	"./ar-EG/_lib/formatLong": 81357,
	"./ar-EG/_lib/formatLong/": 81357,
	"./ar-EG/_lib/formatLong/index": 81357,
	"./ar-EG/_lib/formatLong/index.js": 81357,
	"./ar-EG/_lib/formatRelative": 14789,
	"./ar-EG/_lib/formatRelative/": 14789,
	"./ar-EG/_lib/formatRelative/index": 14789,
	"./ar-EG/_lib/formatRelative/index.js": 14789,
	"./ar-EG/_lib/localize": 76904,
	"./ar-EG/_lib/localize/": 76904,
	"./ar-EG/_lib/localize/index": 76904,
	"./ar-EG/_lib/localize/index.js": 76904,
	"./ar-EG/_lib/match": 52658,
	"./ar-EG/_lib/match/": 52658,
	"./ar-EG/_lib/match/index": 52658,
	"./ar-EG/_lib/match/index.js": 52658,
	"./ar-EG/index": 85866,
	"./ar-EG/index.d.ts": 67183,
	"./ar-EG/index.js": 85866,
	"./ar-EG/index.js.flow": 35593,
	"./ar-EG/package": 79098,
	"./ar-EG/package.json": 79098,
	"./ar-MA": 91847,
	"./ar-MA/": 91847,
	"./ar-MA/_lib/formatDistance": 78679,
	"./ar-MA/_lib/formatDistance/": 78679,
	"./ar-MA/_lib/formatDistance/index": 78679,
	"./ar-MA/_lib/formatDistance/index.js": 78679,
	"./ar-MA/_lib/formatLong": 53463,
	"./ar-MA/_lib/formatLong/": 53463,
	"./ar-MA/_lib/formatLong/index": 53463,
	"./ar-MA/_lib/formatLong/index.js": 53463,
	"./ar-MA/_lib/formatRelative": 52799,
	"./ar-MA/_lib/formatRelative/": 52799,
	"./ar-MA/_lib/formatRelative/index": 52799,
	"./ar-MA/_lib/formatRelative/index.js": 52799,
	"./ar-MA/_lib/localize": 27848,
	"./ar-MA/_lib/localize/": 27848,
	"./ar-MA/_lib/localize/index": 27848,
	"./ar-MA/_lib/localize/index.js": 27848,
	"./ar-MA/_lib/match": 82202,
	"./ar-MA/_lib/match/": 82202,
	"./ar-MA/_lib/match/index": 82202,
	"./ar-MA/_lib/match/index.js": 82202,
	"./ar-MA/index": 12626,
	"./ar-MA/index.d.ts": 31737,
	"./ar-MA/index.js": 12626,
	"./ar-MA/index.js.flow": 28817,
	"./ar-MA/package": 96149,
	"./ar-MA/package.json": 96149,
	"./ar-SA": 64843,
	"./ar-SA/": 64843,
	"./ar-SA/_lib/formatDistance": 47028,
	"./ar-SA/_lib/formatDistance/": 47028,
	"./ar-SA/_lib/formatDistance/index": 47028,
	"./ar-SA/_lib/formatDistance/index.js": 47028,
	"./ar-SA/_lib/formatLong": 31590,
	"./ar-SA/_lib/formatLong/": 31590,
	"./ar-SA/_lib/formatLong/index": 31590,
	"./ar-SA/_lib/formatLong/index.js": 31590,
	"./ar-SA/_lib/formatRelative": 62529,
	"./ar-SA/_lib/formatRelative/": 62529,
	"./ar-SA/_lib/formatRelative/index": 62529,
	"./ar-SA/_lib/formatRelative/index.js": 62529,
	"./ar-SA/_lib/localize": 81670,
	"./ar-SA/_lib/localize/": 81670,
	"./ar-SA/_lib/localize/index": 81670,
	"./ar-SA/_lib/localize/index.js": 81670,
	"./ar-SA/_lib/match": 45832,
	"./ar-SA/_lib/match/": 45832,
	"./ar-SA/_lib/match/index": 45832,
	"./ar-SA/_lib/match/index.js": 45832,
	"./ar-SA/index": 34615,
	"./ar-SA/index.d.ts": 50276,
	"./ar-SA/index.js": 34615,
	"./ar-SA/index.js.flow": 88407,
	"./ar-SA/package": 31751,
	"./ar-SA/package.json": 31751,
	"./ar-TN": 91718,
	"./ar-TN/": 91718,
	"./ar-TN/_lib/formatDistance": 41897,
	"./ar-TN/_lib/formatDistance/": 41897,
	"./ar-TN/_lib/formatDistance/index": 41897,
	"./ar-TN/_lib/formatDistance/index.js": 41897,
	"./ar-TN/_lib/formatLong": 85945,
	"./ar-TN/_lib/formatLong/": 85945,
	"./ar-TN/_lib/formatLong/index": 85945,
	"./ar-TN/_lib/formatLong/index.js": 85945,
	"./ar-TN/_lib/formatRelative": 87609,
	"./ar-TN/_lib/formatRelative/": 87609,
	"./ar-TN/_lib/formatRelative/index": 87609,
	"./ar-TN/_lib/formatRelative/index.js": 87609,
	"./ar-TN/_lib/localize": 20405,
	"./ar-TN/_lib/localize/": 20405,
	"./ar-TN/_lib/localize/index": 20405,
	"./ar-TN/_lib/localize/index.js": 20405,
	"./ar-TN/_lib/match": 62259,
	"./ar-TN/_lib/match/": 62259,
	"./ar-TN/_lib/match/index": 62259,
	"./ar-TN/_lib/match/index.js": 62259,
	"./ar-TN/index": 68285,
	"./ar-TN/index.d.ts": 34986,
	"./ar-TN/index.js": 68285,
	"./ar-TN/index.js.flow": 66457,
	"./ar-TN/package": 91106,
	"./ar-TN/package.json": 91106,
	"./ar/": 89959,
	"./ar/_lib/formatDistance": 11078,
	"./ar/_lib/formatDistance/": 11078,
	"./ar/_lib/formatDistance/index": 11078,
	"./ar/_lib/formatDistance/index.js": 11078,
	"./ar/_lib/formatLong": 56037,
	"./ar/_lib/formatLong/": 56037,
	"./ar/_lib/formatLong/index": 56037,
	"./ar/_lib/formatLong/index.js": 56037,
	"./ar/_lib/formatRelative": 63597,
	"./ar/_lib/formatRelative/": 63597,
	"./ar/_lib/formatRelative/index": 63597,
	"./ar/_lib/formatRelative/index.js": 63597,
	"./ar/_lib/localize": 87411,
	"./ar/_lib/localize/": 87411,
	"./ar/_lib/localize/index": 87411,
	"./ar/_lib/localize/index.js": 87411,
	"./ar/_lib/match": 64356,
	"./ar/_lib/match/": 64356,
	"./ar/_lib/match/index": 64356,
	"./ar/_lib/match/index.js": 64356,
	"./ar/index": 20639,
	"./ar/index.d.ts": 73561,
	"./ar/index.js": 20639,
	"./ar/index.js.flow": 24641,
	"./ar/package": 25354,
	"./ar/package.json": 25354,
	"./az": 42700,
	"./az/": 42700,
	"./az/_lib/formatDistance": 72186,
	"./az/_lib/formatDistance/": 72186,
	"./az/_lib/formatDistance/index": 72186,
	"./az/_lib/formatDistance/index.js": 72186,
	"./az/_lib/formatLong": 17469,
	"./az/_lib/formatLong/": 17469,
	"./az/_lib/formatLong/index": 17469,
	"./az/_lib/formatLong/index.js": 17469,
	"./az/_lib/formatRelative": 28102,
	"./az/_lib/formatRelative/": 28102,
	"./az/_lib/formatRelative/index": 28102,
	"./az/_lib/formatRelative/index.js": 28102,
	"./az/_lib/localize": 93174,
	"./az/_lib/localize/": 93174,
	"./az/_lib/localize/index": 93174,
	"./az/_lib/localize/index.js": 93174,
	"./az/_lib/match": 90964,
	"./az/_lib/match/": 90964,
	"./az/_lib/match/index": 90964,
	"./az/_lib/match/index.js": 90964,
	"./az/index": 60908,
	"./az/index.d.ts": 37452,
	"./az/index.js": 60908,
	"./az/index.js.flow": 72495,
	"./az/package": 46726,
	"./az/package.json": 46726,
	"./be": 17169,
	"./be-tarask": 21605,
	"./be-tarask/": 21605,
	"./be-tarask/_lib/formatDistance": 87028,
	"./be-tarask/_lib/formatDistance/": 87028,
	"./be-tarask/_lib/formatDistance/index": 87028,
	"./be-tarask/_lib/formatDistance/index.js": 87028,
	"./be-tarask/_lib/formatLong": 28387,
	"./be-tarask/_lib/formatLong/": 28387,
	"./be-tarask/_lib/formatLong/index": 28387,
	"./be-tarask/_lib/formatLong/index.js": 28387,
	"./be-tarask/_lib/formatRelative": 56396,
	"./be-tarask/_lib/formatRelative/": 56396,
	"./be-tarask/_lib/formatRelative/index": 56396,
	"./be-tarask/_lib/formatRelative/index.js": 56396,
	"./be-tarask/_lib/localize": 11745,
	"./be-tarask/_lib/localize/": 11745,
	"./be-tarask/_lib/localize/index": 11745,
	"./be-tarask/_lib/localize/index.js": 11745,
	"./be-tarask/_lib/match": 99670,
	"./be-tarask/_lib/match/": 99670,
	"./be-tarask/_lib/match/index": 99670,
	"./be-tarask/_lib/match/index.js": 99670,
	"./be-tarask/index": 58549,
	"./be-tarask/index.d.ts": 20170,
	"./be-tarask/index.js": 58549,
	"./be-tarask/index.js.flow": 43438,
	"./be-tarask/package": 62188,
	"./be-tarask/package.json": 62188,
	"./be/": 17169,
	"./be/_lib/formatDistance": 40833,
	"./be/_lib/formatDistance/": 40833,
	"./be/_lib/formatDistance/index": 40833,
	"./be/_lib/formatDistance/index.js": 40833,
	"./be/_lib/formatLong": 9078,
	"./be/_lib/formatLong/": 9078,
	"./be/_lib/formatLong/index": 9078,
	"./be/_lib/formatLong/index.js": 9078,
	"./be/_lib/formatRelative": 23013,
	"./be/_lib/formatRelative/": 23013,
	"./be/_lib/formatRelative/index": 23013,
	"./be/_lib/formatRelative/index.js": 23013,
	"./be/_lib/localize": 80921,
	"./be/_lib/localize/": 80921,
	"./be/_lib/localize/index": 80921,
	"./be/_lib/localize/index.js": 80921,
	"./be/_lib/match": 9745,
	"./be/_lib/match/": 9745,
	"./be/_lib/match/index": 9745,
	"./be/_lib/match/index.js": 9745,
	"./be/index": 98780,
	"./be/index.d.ts": 76558,
	"./be/index.js": 98780,
	"./be/index.js.flow": 19138,
	"./be/package": 31907,
	"./be/package.json": 31907,
	"./bg": 19065,
	"./bg/": 19065,
	"./bg/_lib/formatDistance": 73838,
	"./bg/_lib/formatDistance/": 73838,
	"./bg/_lib/formatDistance/index": 73838,
	"./bg/_lib/formatDistance/index.js": 73838,
	"./bg/_lib/formatLong": 45777,
	"./bg/_lib/formatLong/": 45777,
	"./bg/_lib/formatLong/index": 45777,
	"./bg/_lib/formatLong/index.js": 45777,
	"./bg/_lib/formatRelative": 53575,
	"./bg/_lib/formatRelative/": 53575,
	"./bg/_lib/formatRelative/index": 53575,
	"./bg/_lib/formatRelative/index.js": 53575,
	"./bg/_lib/localize": 60170,
	"./bg/_lib/localize/": 60170,
	"./bg/_lib/localize/index": 60170,
	"./bg/_lib/localize/index.js": 60170,
	"./bg/_lib/match": 23450,
	"./bg/_lib/match/": 23450,
	"./bg/_lib/match/index": 23450,
	"./bg/_lib/match/index.js": 23450,
	"./bg/index": 56977,
	"./bg/index.d.ts": 96086,
	"./bg/index.js": 56977,
	"./bg/index.js.flow": 53876,
	"./bg/package": 13350,
	"./bg/package.json": 13350,
	"./bn": 83536,
	"./bn/": 83536,
	"./bn/_lib/formatDistance": 79597,
	"./bn/_lib/formatDistance/": 79597,
	"./bn/_lib/formatDistance/index": 79597,
	"./bn/_lib/formatDistance/index.js": 79597,
	"./bn/_lib/formatLong": 57362,
	"./bn/_lib/formatLong/": 57362,
	"./bn/_lib/formatLong/index": 57362,
	"./bn/_lib/formatLong/index.js": 57362,
	"./bn/_lib/formatRelative": 63791,
	"./bn/_lib/formatRelative/": 63791,
	"./bn/_lib/formatRelative/index": 63791,
	"./bn/_lib/formatRelative/index.js": 63791,
	"./bn/_lib/localize": 10854,
	"./bn/_lib/localize/": 10854,
	"./bn/_lib/localize/index": 10854,
	"./bn/_lib/localize/index.js": 10854,
	"./bn/_lib/match": 29480,
	"./bn/_lib/match/": 29480,
	"./bn/_lib/match/index": 29480,
	"./bn/_lib/match/index.js": 29480,
	"./bn/index": 8374,
	"./bn/index.d.ts": 36911,
	"./bn/index.js": 8374,
	"./bn/index.js.flow": 46057,
	"./bn/package": 18686,
	"./bn/package.json": 18686,
	"./bs": 56223,
	"./bs/": 56223,
	"./bs/_lib/formatDistance": 75717,
	"./bs/_lib/formatDistance/": 75717,
	"./bs/_lib/formatDistance/index": 75717,
	"./bs/_lib/formatDistance/index.js": 75717,
	"./bs/_lib/formatLong": 92131,
	"./bs/_lib/formatLong/": 92131,
	"./bs/_lib/formatLong/index": 92131,
	"./bs/_lib/formatLong/index.js": 92131,
	"./bs/_lib/formatRelative": 23369,
	"./bs/_lib/formatRelative/": 23369,
	"./bs/_lib/formatRelative/index": 23369,
	"./bs/_lib/formatRelative/index.js": 23369,
	"./bs/_lib/localize": 4802,
	"./bs/_lib/localize/": 4802,
	"./bs/_lib/localize/index": 4802,
	"./bs/_lib/localize/index.js": 4802,
	"./bs/_lib/match": 19461,
	"./bs/_lib/match/": 19461,
	"./bs/_lib/match/index": 19461,
	"./bs/_lib/match/index.js": 19461,
	"./bs/index": 25309,
	"./bs/index.d.ts": 83217,
	"./bs/index.js": 25309,
	"./bs/index.js.flow": 19871,
	"./bs/package": 5536,
	"./bs/package.json": 5536,
	"./ca": 21428,
	"./ca/": 21428,
	"./ca/_lib/formatDistance": 28833,
	"./ca/_lib/formatDistance/": 28833,
	"./ca/_lib/formatDistance/index": 28833,
	"./ca/_lib/formatDistance/index.js": 28833,
	"./ca/_lib/formatLong": 92031,
	"./ca/_lib/formatLong/": 92031,
	"./ca/_lib/formatLong/index": 92031,
	"./ca/_lib/formatLong/index.js": 92031,
	"./ca/_lib/formatRelative": 31465,
	"./ca/_lib/formatRelative/": 31465,
	"./ca/_lib/formatRelative/index": 31465,
	"./ca/_lib/formatRelative/index.js": 31465,
	"./ca/_lib/localize": 29555,
	"./ca/_lib/localize/": 29555,
	"./ca/_lib/localize/index": 29555,
	"./ca/_lib/localize/index.js": 29555,
	"./ca/_lib/match": 25978,
	"./ca/_lib/match/": 25978,
	"./ca/_lib/match/index": 25978,
	"./ca/_lib/match/index.js": 25978,
	"./ca/index": 27644,
	"./ca/index.d.ts": 64176,
	"./ca/index.js": 27644,
	"./ca/index.js.flow": 38867,
	"./ca/package": 76248,
	"./ca/package.json": 76248,
	"./cs": 85322,
	"./cs/": 85322,
	"./cs/_lib/formatDistance": 64077,
	"./cs/_lib/formatDistance/": 64077,
	"./cs/_lib/formatDistance/index": 64077,
	"./cs/_lib/formatDistance/index.js": 64077,
	"./cs/_lib/formatLong": 17080,
	"./cs/_lib/formatLong/": 17080,
	"./cs/_lib/formatLong/index": 17080,
	"./cs/_lib/formatLong/index.js": 17080,
	"./cs/_lib/formatRelative": 81029,
	"./cs/_lib/formatRelative/": 81029,
	"./cs/_lib/formatRelative/index": 81029,
	"./cs/_lib/formatRelative/index.js": 81029,
	"./cs/_lib/localize": 828,
	"./cs/_lib/localize/": 828,
	"./cs/_lib/localize/index": 828,
	"./cs/_lib/localize/index.js": 828,
	"./cs/_lib/match": 59087,
	"./cs/_lib/match/": 59087,
	"./cs/_lib/match/index": 59087,
	"./cs/_lib/match/index.js": 59087,
	"./cs/index": 1163,
	"./cs/index.d.ts": 7131,
	"./cs/index.js": 1163,
	"./cs/index.js.flow": 46301,
	"./cs/package": 8538,
	"./cs/package.json": 8538,
	"./cy": 15636,
	"./cy/": 15636,
	"./cy/_lib/formatDistance": 95134,
	"./cy/_lib/formatDistance/": 95134,
	"./cy/_lib/formatDistance/index": 95134,
	"./cy/_lib/formatDistance/index.js": 95134,
	"./cy/_lib/formatLong": 20128,
	"./cy/_lib/formatLong/": 20128,
	"./cy/_lib/formatLong/index": 20128,
	"./cy/_lib/formatLong/index.js": 20128,
	"./cy/_lib/formatRelative": 20703,
	"./cy/_lib/formatRelative/": 20703,
	"./cy/_lib/formatRelative/index": 20703,
	"./cy/_lib/formatRelative/index.js": 20703,
	"./cy/_lib/localize": 64321,
	"./cy/_lib/localize/": 64321,
	"./cy/_lib/localize/index": 64321,
	"./cy/_lib/localize/index.js": 64321,
	"./cy/_lib/match": 11401,
	"./cy/_lib/match/": 11401,
	"./cy/_lib/match/index": 11401,
	"./cy/_lib/match/index.js": 11401,
	"./cy/index": 7187,
	"./cy/index.d.ts": 71848,
	"./cy/index.js": 7187,
	"./cy/index.js.flow": 38903,
	"./cy/package": 97130,
	"./cy/package.json": 97130,
	"./da": 85698,
	"./da/": 85698,
	"./da/_lib/formatDistance": 55452,
	"./da/_lib/formatDistance/": 55452,
	"./da/_lib/formatDistance/index": 55452,
	"./da/_lib/formatDistance/index.js": 55452,
	"./da/_lib/formatLong": 97530,
	"./da/_lib/formatLong/": 97530,
	"./da/_lib/formatLong/index": 97530,
	"./da/_lib/formatLong/index.js": 97530,
	"./da/_lib/formatRelative": 17743,
	"./da/_lib/formatRelative/": 17743,
	"./da/_lib/formatRelative/index": 17743,
	"./da/_lib/formatRelative/index.js": 17743,
	"./da/_lib/localize": 70952,
	"./da/_lib/localize/": 70952,
	"./da/_lib/localize/index": 70952,
	"./da/_lib/localize/index.js": 70952,
	"./da/_lib/match": 65127,
	"./da/_lib/match/": 65127,
	"./da/_lib/match/index": 65127,
	"./da/_lib/match/index.js": 65127,
	"./da/index": 30087,
	"./da/index.d.ts": 78882,
	"./da/index.js": 30087,
	"./da/index.js.flow": 21162,
	"./da/package": 15923,
	"./da/package.json": 15923,
	"./de": 89590,
	"./de-AT": 16213,
	"./de-AT/": 16213,
	"./de-AT/_lib/localize": 83720,
	"./de-AT/_lib/localize/": 83720,
	"./de-AT/_lib/localize/index": 83720,
	"./de-AT/_lib/localize/index.js": 83720,
	"./de-AT/index": 70746,
	"./de-AT/index.d.ts": 10757,
	"./de-AT/index.js": 70746,
	"./de-AT/index.js.flow": 62004,
	"./de-AT/package": 51236,
	"./de-AT/package.json": 51236,
	"./de/": 89590,
	"./de/_lib/formatDistance": 28853,
	"./de/_lib/formatDistance/": 28853,
	"./de/_lib/formatDistance/index": 28853,
	"./de/_lib/formatDistance/index.js": 28853,
	"./de/_lib/formatLong": 66787,
	"./de/_lib/formatLong/": 66787,
	"./de/_lib/formatLong/index": 66787,
	"./de/_lib/formatLong/index.js": 66787,
	"./de/_lib/formatRelative": 58119,
	"./de/_lib/formatRelative/": 58119,
	"./de/_lib/formatRelative/index": 58119,
	"./de/_lib/formatRelative/index.js": 58119,
	"./de/_lib/localize": 68120,
	"./de/_lib/localize/": 68120,
	"./de/_lib/localize/index": 68120,
	"./de/_lib/localize/index.js": 68120,
	"./de/_lib/match": 85376,
	"./de/_lib/match/": 85376,
	"./de/_lib/match/index": 85376,
	"./de/_lib/match/index.js": 85376,
	"./de/index": 33370,
	"./de/index.d.ts": 37795,
	"./de/index.js": 33370,
	"./de/index.js.flow": 86732,
	"./de/package": 28125,
	"./de/package.json": 28125,
	"./el": 40293,
	"./el/": 40293,
	"./el/_lib/formatDistance": 18472,
	"./el/_lib/formatDistance/": 18472,
	"./el/_lib/formatDistance/index": 18472,
	"./el/_lib/formatDistance/index.js": 18472,
	"./el/_lib/formatLong": 63400,
	"./el/_lib/formatLong/": 63400,
	"./el/_lib/formatLong/index": 63400,
	"./el/_lib/formatLong/index.js": 63400,
	"./el/_lib/formatRelative": 23193,
	"./el/_lib/formatRelative/": 23193,
	"./el/_lib/formatRelative/index": 23193,
	"./el/_lib/formatRelative/index.js": 23193,
	"./el/_lib/localize": 76013,
	"./el/_lib/localize/": 76013,
	"./el/_lib/localize/index": 76013,
	"./el/_lib/localize/index.js": 76013,
	"./el/_lib/match": 96428,
	"./el/_lib/match/": 96428,
	"./el/_lib/match/index": 96428,
	"./el/_lib/match/index.js": 96428,
	"./el/index": 15433,
	"./el/index.d.ts": 928,
	"./el/index.js": 15433,
	"./el/index.js.flow": 9449,
	"./el/package": 93626,
	"./el/package.json": 93626,
	"./en-AU": 37135,
	"./en-AU/": 37135,
	"./en-AU/_lib/formatLong": 40841,
	"./en-AU/_lib/formatLong/": 40841,
	"./en-AU/_lib/formatLong/index": 40841,
	"./en-AU/_lib/formatLong/index.js": 40841,
	"./en-AU/index": 40127,
	"./en-AU/index.d.ts": 64135,
	"./en-AU/index.js": 40127,
	"./en-AU/index.js.flow": 66022,
	"./en-AU/package": 86340,
	"./en-AU/package.json": 86340,
	"./en-CA": 76268,
	"./en-CA/": 76268,
	"./en-CA/_lib/formatDistance": 16408,
	"./en-CA/_lib/formatDistance/": 16408,
	"./en-CA/_lib/formatDistance/index": 16408,
	"./en-CA/_lib/formatDistance/index.js": 16408,
	"./en-CA/_lib/formatLong": 18064,
	"./en-CA/_lib/formatLong/": 18064,
	"./en-CA/_lib/formatLong/index": 18064,
	"./en-CA/_lib/formatLong/index.js": 18064,
	"./en-CA/index": 72705,
	"./en-CA/index.d.ts": 96624,
	"./en-CA/index.js": 72705,
	"./en-CA/index.js.flow": 70664,
	"./en-CA/package": 62051,
	"./en-CA/package.json": 62051,
	"./en-GB": 38432,
	"./en-GB/": 38432,
	"./en-GB/_lib/formatLong": 70841,
	"./en-GB/_lib/formatLong/": 70841,
	"./en-GB/_lib/formatLong/index": 70841,
	"./en-GB/_lib/formatLong/index.js": 70841,
	"./en-GB/index": 88002,
	"./en-GB/index.d.ts": 38015,
	"./en-GB/index.js": 88002,
	"./en-GB/index.js.flow": 30123,
	"./en-GB/package": 33856,
	"./en-GB/package.json": 33856,
	"./en-IE": 31930,
	"./en-IE/": 31930,
	"./en-IE/index": 2756,
	"./en-IE/index.d.ts": 13556,
	"./en-IE/index.js": 2756,
	"./en-IE/index.js.flow": 1887,
	"./en-IE/package": 61267,
	"./en-IE/package.json": 61267,
	"./en-IN": 96968,
	"./en-IN/": 96968,
	"./en-IN/_lib/formatLong": 89503,
	"./en-IN/_lib/formatLong/": 89503,
	"./en-IN/_lib/formatLong/index": 89503,
	"./en-IN/_lib/formatLong/index.js": 89503,
	"./en-IN/index": 39787,
	"./en-IN/index.d.ts": 47189,
	"./en-IN/index.js": 39787,
	"./en-IN/index.js.flow": 48551,
	"./en-IN/package": 2411,
	"./en-IN/package.json": 2411,
	"./en-NZ": 90479,
	"./en-NZ/": 90479,
	"./en-NZ/_lib/formatLong": 37381,
	"./en-NZ/_lib/formatLong/": 37381,
	"./en-NZ/_lib/formatLong/index": 37381,
	"./en-NZ/_lib/formatLong/index.js": 37381,
	"./en-NZ/index": 75715,
	"./en-NZ/index.d.ts": 12543,
	"./en-NZ/index.js": 75715,
	"./en-NZ/index.js.flow": 72755,
	"./en-NZ/package": 78638,
	"./en-NZ/package.json": 78638,
	"./en-US": 72713,
	"./en-US/": 72713,
	"./en-US/_lib/formatDistance": 82181,
	"./en-US/_lib/formatDistance/": 82181,
	"./en-US/_lib/formatDistance/index": 82181,
	"./en-US/_lib/formatDistance/index.js": 82181,
	"./en-US/_lib/formatLong": 83177,
	"./en-US/_lib/formatLong/": 83177,
	"./en-US/_lib/formatLong/index": 83177,
	"./en-US/_lib/formatLong/index.js": 83177,
	"./en-US/_lib/formatRelative": 62720,
	"./en-US/_lib/formatRelative/": 62720,
	"./en-US/_lib/formatRelative/index": 62720,
	"./en-US/_lib/formatRelative/index.js": 62720,
	"./en-US/_lib/localize": 2137,
	"./en-US/_lib/localize/": 2137,
	"./en-US/_lib/localize/index": 2137,
	"./en-US/_lib/localize/index.js": 2137,
	"./en-US/_lib/match": 46034,
	"./en-US/_lib/match/": 46034,
	"./en-US/_lib/match/index": 46034,
	"./en-US/_lib/match/index.js": 46034,
	"./en-US/index": 31881,
	"./en-US/index.d.ts": 36008,
	"./en-US/index.js": 31881,
	"./en-US/index.js.flow": 15204,
	"./en-US/package": 73022,
	"./en-US/package.json": 73022,
	"./en-ZA": 5029,
	"./en-ZA/": 5029,
	"./en-ZA/_lib/formatLong": 488,
	"./en-ZA/_lib/formatLong/": 488,
	"./en-ZA/_lib/formatLong/index": 488,
	"./en-ZA/_lib/formatLong/index.js": 488,
	"./en-ZA/index": 80266,
	"./en-ZA/index.d.ts": 52411,
	"./en-ZA/index.js": 80266,
	"./en-ZA/index.js.flow": 98262,
	"./en-ZA/package": 29946,
	"./en-ZA/package.json": 29946,
	"./eo": 9065,
	"./eo/": 9065,
	"./eo/_lib/formatDistance": 99102,
	"./eo/_lib/formatDistance/": 99102,
	"./eo/_lib/formatDistance/index": 99102,
	"./eo/_lib/formatDistance/index.js": 99102,
	"./eo/_lib/formatLong": 40012,
	"./eo/_lib/formatLong/": 40012,
	"./eo/_lib/formatLong/index": 40012,
	"./eo/_lib/formatLong/index.js": 40012,
	"./eo/_lib/formatRelative": 34468,
	"./eo/_lib/formatRelative/": 34468,
	"./eo/_lib/formatRelative/index": 34468,
	"./eo/_lib/formatRelative/index.js": 34468,
	"./eo/_lib/localize": 62738,
	"./eo/_lib/localize/": 62738,
	"./eo/_lib/localize/index": 62738,
	"./eo/_lib/localize/index.js": 62738,
	"./eo/_lib/match": 51252,
	"./eo/_lib/match/": 51252,
	"./eo/_lib/match/index": 51252,
	"./eo/_lib/match/index.js": 51252,
	"./eo/index": 34022,
	"./eo/index.d.ts": 95241,
	"./eo/index.js": 34022,
	"./eo/index.js.flow": 91326,
	"./eo/package": 94915,
	"./eo/package.json": 94915,
	"./es": 12767,
	"./es/": 12767,
	"./es/_lib/formatDistance": 174,
	"./es/_lib/formatDistance/": 174,
	"./es/_lib/formatDistance/index": 174,
	"./es/_lib/formatDistance/index.js": 174,
	"./es/_lib/formatLong": 44229,
	"./es/_lib/formatLong/": 44229,
	"./es/_lib/formatLong/index": 44229,
	"./es/_lib/formatLong/index.js": 44229,
	"./es/_lib/formatRelative": 81581,
	"./es/_lib/formatRelative/": 81581,
	"./es/_lib/formatRelative/index": 81581,
	"./es/_lib/formatRelative/index.js": 81581,
	"./es/_lib/localize": 84412,
	"./es/_lib/localize/": 84412,
	"./es/_lib/localize/index": 84412,
	"./es/_lib/localize/index.js": 84412,
	"./es/_lib/match": 3551,
	"./es/_lib/match/": 3551,
	"./es/_lib/match/index": 3551,
	"./es/_lib/match/index.js": 3551,
	"./es/index": 96215,
	"./es/index.d.ts": 13117,
	"./es/index.js": 96215,
	"./es/index.js.flow": 22919,
	"./es/package": 85771,
	"./es/package.json": 85771,
	"./et": 59550,
	"./et/": 59550,
	"./et/_lib/formatDistance": 95412,
	"./et/_lib/formatDistance/": 95412,
	"./et/_lib/formatDistance/index": 95412,
	"./et/_lib/formatDistance/index.js": 95412,
	"./et/_lib/formatLong": 85065,
	"./et/_lib/formatLong/": 85065,
	"./et/_lib/formatLong/index": 85065,
	"./et/_lib/formatLong/index.js": 85065,
	"./et/_lib/formatRelative": 29326,
	"./et/_lib/formatRelative/": 29326,
	"./et/_lib/formatRelative/index": 29326,
	"./et/_lib/formatRelative/index.js": 29326,
	"./et/_lib/localize": 73105,
	"./et/_lib/localize/": 73105,
	"./et/_lib/localize/index": 73105,
	"./et/_lib/localize/index.js": 73105,
	"./et/_lib/match": 10939,
	"./et/_lib/match/": 10939,
	"./et/_lib/match/index": 10939,
	"./et/_lib/match/index.js": 10939,
	"./et/index": 61411,
	"./et/index.d.ts": 60197,
	"./et/index.js": 61411,
	"./et/index.js.flow": 56773,
	"./et/package": 95821,
	"./et/package.json": 95821,
	"./eu": 88530,
	"./eu/": 88530,
	"./eu/_lib/formatDistance": 89780,
	"./eu/_lib/formatDistance/": 89780,
	"./eu/_lib/formatDistance/index": 89780,
	"./eu/_lib/formatDistance/index.js": 89780,
	"./eu/_lib/formatLong": 21638,
	"./eu/_lib/formatLong/": 21638,
	"./eu/_lib/formatLong/index": 21638,
	"./eu/_lib/formatLong/index.js": 21638,
	"./eu/_lib/formatRelative": 63972,
	"./eu/_lib/formatRelative/": 63972,
	"./eu/_lib/formatRelative/index": 63972,
	"./eu/_lib/formatRelative/index.js": 63972,
	"./eu/_lib/localize": 8886,
	"./eu/_lib/localize/": 8886,
	"./eu/_lib/localize/index": 8886,
	"./eu/_lib/localize/index.js": 8886,
	"./eu/_lib/match": 7403,
	"./eu/_lib/match/": 7403,
	"./eu/_lib/match/index": 7403,
	"./eu/_lib/match/index.js": 7403,
	"./eu/index": 68167,
	"./eu/index.d.ts": 81622,
	"./eu/index.js": 68167,
	"./eu/index.js.flow": 53737,
	"./eu/package": 69919,
	"./eu/package.json": 69919,
	"./fa-IR": 4195,
	"./fa-IR/": 4195,
	"./fa-IR/_lib/formatDistance": 54168,
	"./fa-IR/_lib/formatDistance/": 54168,
	"./fa-IR/_lib/formatDistance/index": 54168,
	"./fa-IR/_lib/formatDistance/index.js": 54168,
	"./fa-IR/_lib/formatLong": 87834,
	"./fa-IR/_lib/formatLong/": 87834,
	"./fa-IR/_lib/formatLong/index": 87834,
	"./fa-IR/_lib/formatLong/index.js": 87834,
	"./fa-IR/_lib/formatRelative": 69793,
	"./fa-IR/_lib/formatRelative/": 69793,
	"./fa-IR/_lib/formatRelative/index": 69793,
	"./fa-IR/_lib/formatRelative/index.js": 69793,
	"./fa-IR/_lib/localize": 4031,
	"./fa-IR/_lib/localize/": 4031,
	"./fa-IR/_lib/localize/index": 4031,
	"./fa-IR/_lib/localize/index.js": 4031,
	"./fa-IR/_lib/match": 51159,
	"./fa-IR/_lib/match/": 51159,
	"./fa-IR/_lib/match/index": 51159,
	"./fa-IR/_lib/match/index.js": 51159,
	"./fa-IR/index": 340,
	"./fa-IR/index.d.ts": 36716,
	"./fa-IR/index.js": 340,
	"./fa-IR/index.js.flow": 33491,
	"./fa-IR/package": 20194,
	"./fa-IR/package.json": 20194,
	"./fi": 45119,
	"./fi/": 45119,
	"./fi/_lib/formatDistance": 48882,
	"./fi/_lib/formatDistance/": 48882,
	"./fi/_lib/formatDistance/index": 48882,
	"./fi/_lib/formatDistance/index.js": 48882,
	"./fi/_lib/formatLong": 94604,
	"./fi/_lib/formatLong/": 94604,
	"./fi/_lib/formatLong/index": 94604,
	"./fi/_lib/formatLong/index.js": 94604,
	"./fi/_lib/formatRelative": 40415,
	"./fi/_lib/formatRelative/": 40415,
	"./fi/_lib/formatRelative/index": 40415,
	"./fi/_lib/formatRelative/index.js": 40415,
	"./fi/_lib/localize": 94049,
	"./fi/_lib/localize/": 94049,
	"./fi/_lib/localize/index": 94049,
	"./fi/_lib/localize/index.js": 94049,
	"./fi/_lib/match": 70528,
	"./fi/_lib/match/": 70528,
	"./fi/_lib/match/index": 70528,
	"./fi/_lib/match/index.js": 70528,
	"./fi/index": 60816,
	"./fi/index.d.ts": 79761,
	"./fi/index.js": 60816,
	"./fi/index.js.flow": 37539,
	"./fi/package": 64026,
	"./fi/package.json": 64026,
	"./fr": 31361,
	"./fr-CA": 89575,
	"./fr-CA/": 89575,
	"./fr-CA/_lib/formatLong": 59955,
	"./fr-CA/_lib/formatLong/": 59955,
	"./fr-CA/_lib/formatLong/index": 59955,
	"./fr-CA/_lib/formatLong/index.js": 59955,
	"./fr-CA/index": 59644,
	"./fr-CA/index.d.ts": 9990,
	"./fr-CA/index.js": 59644,
	"./fr-CA/index.js.flow": 60685,
	"./fr-CA/package": 53937,
	"./fr-CA/package.json": 53937,
	"./fr-CH": 24921,
	"./fr-CH/": 24921,
	"./fr-CH/_lib/formatLong": 55715,
	"./fr-CH/_lib/formatLong/": 55715,
	"./fr-CH/_lib/formatLong/index": 55715,
	"./fr-CH/_lib/formatLong/index.js": 55715,
	"./fr-CH/_lib/formatRelative": 90744,
	"./fr-CH/_lib/formatRelative/": 90744,
	"./fr-CH/_lib/formatRelative/index": 90744,
	"./fr-CH/_lib/formatRelative/index.js": 90744,
	"./fr-CH/index": 96592,
	"./fr-CH/index.d.ts": 64432,
	"./fr-CH/index.js": 96592,
	"./fr-CH/index.js.flow": 9739,
	"./fr-CH/package": 80811,
	"./fr-CH/package.json": 80811,
	"./fr/": 31361,
	"./fr/_lib/formatDistance": 17931,
	"./fr/_lib/formatDistance/": 17931,
	"./fr/_lib/formatDistance/index": 17931,
	"./fr/_lib/formatDistance/index.js": 17931,
	"./fr/_lib/formatLong": 82174,
	"./fr/_lib/formatLong/": 82174,
	"./fr/_lib/formatLong/index": 82174,
	"./fr/_lib/formatLong/index.js": 82174,
	"./fr/_lib/formatRelative": 4246,
	"./fr/_lib/formatRelative/": 4246,
	"./fr/_lib/formatRelative/index": 4246,
	"./fr/_lib/formatRelative/index.js": 4246,
	"./fr/_lib/localize": 80648,
	"./fr/_lib/localize/": 80648,
	"./fr/_lib/localize/index": 80648,
	"./fr/_lib/localize/index.js": 80648,
	"./fr/_lib/match": 88887,
	"./fr/_lib/match/": 88887,
	"./fr/_lib/match/index": 88887,
	"./fr/_lib/match/index.js": 88887,
	"./fr/index": 59958,
	"./fr/index.d.ts": 23233,
	"./fr/index.js": 59958,
	"./fr/index.js.flow": 11328,
	"./fr/package": 22075,
	"./fr/package.json": 22075,
	"./fy": 84217,
	"./fy/": 84217,
	"./fy/_lib/formatDistance": 66310,
	"./fy/_lib/formatDistance/": 66310,
	"./fy/_lib/formatDistance/index": 66310,
	"./fy/_lib/formatDistance/index.js": 66310,
	"./fy/_lib/formatLong": 35342,
	"./fy/_lib/formatLong/": 35342,
	"./fy/_lib/formatLong/index": 35342,
	"./fy/_lib/formatLong/index.js": 35342,
	"./fy/_lib/formatRelative": 31681,
	"./fy/_lib/formatRelative/": 31681,
	"./fy/_lib/formatRelative/index": 31681,
	"./fy/_lib/formatRelative/index.js": 31681,
	"./fy/_lib/localize": 5597,
	"./fy/_lib/localize/": 5597,
	"./fy/_lib/localize/index": 5597,
	"./fy/_lib/localize/index.js": 5597,
	"./fy/_lib/match": 85815,
	"./fy/_lib/match/": 85815,
	"./fy/_lib/match/index": 85815,
	"./fy/_lib/match/index.js": 85815,
	"./fy/index": 25825,
	"./fy/index.d.ts": 83005,
	"./fy/index.js": 25825,
	"./fy/index.js.flow": 17891,
	"./fy/package": 28898,
	"./fy/package.json": 28898,
	"./gd": 35090,
	"./gd/": 35090,
	"./gd/_lib/formatDistance": 45394,
	"./gd/_lib/formatDistance/": 45394,
	"./gd/_lib/formatDistance/index": 45394,
	"./gd/_lib/formatDistance/index.js": 45394,
	"./gd/_lib/formatLong": 7750,
	"./gd/_lib/formatLong/": 7750,
	"./gd/_lib/formatLong/index": 7750,
	"./gd/_lib/formatLong/index.js": 7750,
	"./gd/_lib/formatRelative": 99413,
	"./gd/_lib/formatRelative/": 99413,
	"./gd/_lib/formatRelative/index": 99413,
	"./gd/_lib/formatRelative/index.js": 99413,
	"./gd/_lib/localize": 47300,
	"./gd/_lib/localize/": 47300,
	"./gd/_lib/localize/index": 47300,
	"./gd/_lib/localize/index.js": 47300,
	"./gd/_lib/match": 83394,
	"./gd/_lib/match/": 83394,
	"./gd/_lib/match/index": 83394,
	"./gd/_lib/match/index.js": 83394,
	"./gd/index": 40488,
	"./gd/index.d.ts": 63485,
	"./gd/index.js": 40488,
	"./gd/index.js.flow": 97349,
	"./gd/package": 63494,
	"./gd/package.json": 63494,
	"./gl": 84112,
	"./gl/": 84112,
	"./gl/_lib/formatDistance": 58262,
	"./gl/_lib/formatDistance/": 58262,
	"./gl/_lib/formatDistance/index": 58262,
	"./gl/_lib/formatDistance/index.js": 58262,
	"./gl/_lib/formatLong": 83563,
	"./gl/_lib/formatLong/": 83563,
	"./gl/_lib/formatLong/index": 83563,
	"./gl/_lib/formatLong/index.js": 83563,
	"./gl/_lib/formatRelative": 10606,
	"./gl/_lib/formatRelative/": 10606,
	"./gl/_lib/formatRelative/index": 10606,
	"./gl/_lib/formatRelative/index.js": 10606,
	"./gl/_lib/localize": 87042,
	"./gl/_lib/localize/": 87042,
	"./gl/_lib/localize/index": 87042,
	"./gl/_lib/localize/index.js": 87042,
	"./gl/_lib/match": 33406,
	"./gl/_lib/match/": 33406,
	"./gl/_lib/match/index": 33406,
	"./gl/_lib/match/index.js": 33406,
	"./gl/index": 55296,
	"./gl/index.d.ts": 33545,
	"./gl/index.js": 55296,
	"./gl/index.js.flow": 2279,
	"./gl/package": 39872,
	"./gl/package.json": 39872,
	"./gu": 48373,
	"./gu/": 48373,
	"./gu/_lib/formatDistance": 87936,
	"./gu/_lib/formatDistance/": 87936,
	"./gu/_lib/formatDistance/index": 87936,
	"./gu/_lib/formatDistance/index.js": 87936,
	"./gu/_lib/formatLong": 22068,
	"./gu/_lib/formatLong/": 22068,
	"./gu/_lib/formatLong/index": 22068,
	"./gu/_lib/formatLong/index.js": 22068,
	"./gu/_lib/formatRelative": 5136,
	"./gu/_lib/formatRelative/": 5136,
	"./gu/_lib/formatRelative/index": 5136,
	"./gu/_lib/formatRelative/index.js": 5136,
	"./gu/_lib/localize": 9506,
	"./gu/_lib/localize/": 9506,
	"./gu/_lib/localize/index": 9506,
	"./gu/_lib/localize/index.js": 9506,
	"./gu/_lib/match": 31082,
	"./gu/_lib/match/": 31082,
	"./gu/_lib/match/index": 31082,
	"./gu/_lib/match/index.js": 31082,
	"./gu/index": 6914,
	"./gu/index.d.ts": 14011,
	"./gu/index.js": 6914,
	"./gu/index.js.flow": 61849,
	"./gu/package": 84097,
	"./gu/package.json": 84097,
	"./he": 69110,
	"./he/": 69110,
	"./he/_lib/formatDistance": 13815,
	"./he/_lib/formatDistance/": 13815,
	"./he/_lib/formatDistance/index": 13815,
	"./he/_lib/formatDistance/index.js": 13815,
	"./he/_lib/formatLong": 21441,
	"./he/_lib/formatLong/": 21441,
	"./he/_lib/formatLong/index": 21441,
	"./he/_lib/formatLong/index.js": 21441,
	"./he/_lib/formatRelative": 76812,
	"./he/_lib/formatRelative/": 76812,
	"./he/_lib/formatRelative/index": 76812,
	"./he/_lib/formatRelative/index.js": 76812,
	"./he/_lib/localize": 81200,
	"./he/_lib/localize/": 81200,
	"./he/_lib/localize/index": 81200,
	"./he/_lib/localize/index.js": 81200,
	"./he/_lib/match": 7066,
	"./he/_lib/match/": 7066,
	"./he/_lib/match/index": 7066,
	"./he/_lib/match/index.js": 7066,
	"./he/index": 95861,
	"./he/index.d.ts": 22817,
	"./he/index.js": 95861,
	"./he/index.js.flow": 78356,
	"./he/package": 43089,
	"./he/package.json": 43089,
	"./hi": 36515,
	"./hi/": 36515,
	"./hi/_lib/formatDistance": 1360,
	"./hi/_lib/formatDistance/": 1360,
	"./hi/_lib/formatDistance/index": 1360,
	"./hi/_lib/formatDistance/index.js": 1360,
	"./hi/_lib/formatLong": 77498,
	"./hi/_lib/formatLong/": 77498,
	"./hi/_lib/formatLong/index": 77498,
	"./hi/_lib/formatLong/index.js": 77498,
	"./hi/_lib/formatRelative": 95894,
	"./hi/_lib/formatRelative/": 95894,
	"./hi/_lib/formatRelative/index": 95894,
	"./hi/_lib/formatRelative/index.js": 95894,
	"./hi/_lib/localize": 12979,
	"./hi/_lib/localize/": 12979,
	"./hi/_lib/localize/index": 12979,
	"./hi/_lib/localize/index.js": 12979,
	"./hi/_lib/match": 45497,
	"./hi/_lib/match/": 45497,
	"./hi/_lib/match/index": 45497,
	"./hi/_lib/match/index.js": 45497,
	"./hi/index": 75180,
	"./hi/index.d.ts": 18885,
	"./hi/index.js": 75180,
	"./hi/index.js.flow": 94113,
	"./hi/package": 77402,
	"./hi/package.json": 77402,
	"./hr": 60216,
	"./hr/": 60216,
	"./hr/_lib/formatDistance": 34139,
	"./hr/_lib/formatDistance/": 34139,
	"./hr/_lib/formatDistance/index": 34139,
	"./hr/_lib/formatDistance/index.js": 34139,
	"./hr/_lib/formatLong": 69092,
	"./hr/_lib/formatLong/": 69092,
	"./hr/_lib/formatLong/index": 69092,
	"./hr/_lib/formatLong/index.js": 69092,
	"./hr/_lib/formatRelative": 75311,
	"./hr/_lib/formatRelative/": 75311,
	"./hr/_lib/formatRelative/index": 75311,
	"./hr/_lib/formatRelative/index.js": 75311,
	"./hr/_lib/localize": 97545,
	"./hr/_lib/localize/": 97545,
	"./hr/_lib/localize/index": 97545,
	"./hr/_lib/localize/index.js": 97545,
	"./hr/_lib/match": 30564,
	"./hr/_lib/match/": 30564,
	"./hr/_lib/match/index": 30564,
	"./hr/_lib/match/index.js": 30564,
	"./hr/index": 79721,
	"./hr/index.d.ts": 17052,
	"./hr/index.js": 79721,
	"./hr/index.js.flow": 34906,
	"./hr/package": 65630,
	"./hr/package.json": 65630,
	"./ht": 29113,
	"./ht/": 29113,
	"./ht/_lib/formatDistance": 5023,
	"./ht/_lib/formatDistance/": 5023,
	"./ht/_lib/formatDistance/index": 5023,
	"./ht/_lib/formatDistance/index.js": 5023,
	"./ht/_lib/formatLong": 5935,
	"./ht/_lib/formatLong/": 5935,
	"./ht/_lib/formatLong/index": 5935,
	"./ht/_lib/formatLong/index.js": 5935,
	"./ht/_lib/formatRelative": 95929,
	"./ht/_lib/formatRelative/": 95929,
	"./ht/_lib/formatRelative/index": 95929,
	"./ht/_lib/formatRelative/index.js": 95929,
	"./ht/_lib/localize": 17950,
	"./ht/_lib/localize/": 17950,
	"./ht/_lib/localize/index": 17950,
	"./ht/_lib/localize/index.js": 17950,
	"./ht/_lib/match": 1222,
	"./ht/_lib/match/": 1222,
	"./ht/_lib/match/index": 1222,
	"./ht/_lib/match/index.js": 1222,
	"./ht/index": 94896,
	"./ht/index.d.ts": 15520,
	"./ht/index.js": 94896,
	"./ht/index.js.flow": 52467,
	"./ht/package": 53873,
	"./ht/package.json": 53873,
	"./hu": 78931,
	"./hu/": 78931,
	"./hu/_lib/formatDistance": 9058,
	"./hu/_lib/formatDistance/": 9058,
	"./hu/_lib/formatDistance/index": 9058,
	"./hu/_lib/formatDistance/index.js": 9058,
	"./hu/_lib/formatLong": 56810,
	"./hu/_lib/formatLong/": 56810,
	"./hu/_lib/formatLong/index": 56810,
	"./hu/_lib/formatLong/index.js": 56810,
	"./hu/_lib/formatRelative": 47415,
	"./hu/_lib/formatRelative/": 47415,
	"./hu/_lib/formatRelative/index": 47415,
	"./hu/_lib/formatRelative/index.js": 47415,
	"./hu/_lib/localize": 54700,
	"./hu/_lib/localize/": 54700,
	"./hu/_lib/localize/index": 54700,
	"./hu/_lib/localize/index.js": 54700,
	"./hu/_lib/match": 9413,
	"./hu/_lib/match/": 9413,
	"./hu/_lib/match/index": 9413,
	"./hu/_lib/match/index.js": 9413,
	"./hu/index": 79874,
	"./hu/index.d.ts": 49049,
	"./hu/index.js": 79874,
	"./hu/index.js.flow": 20126,
	"./hu/package": 99882,
	"./hu/package.json": 99882,
	"./hy": 16150,
	"./hy/": 16150,
	"./hy/_lib/formatDistance": 63143,
	"./hy/_lib/formatDistance/": 63143,
	"./hy/_lib/formatDistance/index": 63143,
	"./hy/_lib/formatDistance/index.js": 63143,
	"./hy/_lib/formatLong": 2466,
	"./hy/_lib/formatLong/": 2466,
	"./hy/_lib/formatLong/index": 2466,
	"./hy/_lib/formatLong/index.js": 2466,
	"./hy/_lib/formatRelative": 43475,
	"./hy/_lib/formatRelative/": 43475,
	"./hy/_lib/formatRelative/index": 43475,
	"./hy/_lib/formatRelative/index.js": 43475,
	"./hy/_lib/localize": 6835,
	"./hy/_lib/localize/": 6835,
	"./hy/_lib/localize/index": 6835,
	"./hy/_lib/localize/index.js": 6835,
	"./hy/_lib/match": 14391,
	"./hy/_lib/match/": 14391,
	"./hy/_lib/match/index": 14391,
	"./hy/_lib/match/index.js": 14391,
	"./hy/index": 53929,
	"./hy/index.d.ts": 25800,
	"./hy/index.js": 53929,
	"./hy/index.js.flow": 86430,
	"./hy/package": 78038,
	"./hy/package.json": 78038,
	"./id": 65550,
	"./id/": 65550,
	"./id/_lib/formatDistance": 22925,
	"./id/_lib/formatDistance/": 22925,
	"./id/_lib/formatDistance/index": 22925,
	"./id/_lib/formatDistance/index.js": 22925,
	"./id/_lib/formatLong": 70407,
	"./id/_lib/formatLong/": 70407,
	"./id/_lib/formatLong/index": 70407,
	"./id/_lib/formatLong/index.js": 70407,
	"./id/_lib/formatRelative": 47362,
	"./id/_lib/formatRelative/": 47362,
	"./id/_lib/formatRelative/index": 47362,
	"./id/_lib/formatRelative/index.js": 47362,
	"./id/_lib/localize": 79751,
	"./id/_lib/localize/": 79751,
	"./id/_lib/localize/index": 79751,
	"./id/_lib/localize/index.js": 79751,
	"./id/_lib/match": 20327,
	"./id/_lib/match/": 20327,
	"./id/_lib/match/index": 20327,
	"./id/_lib/match/index.js": 20327,
	"./id/index": 47796,
	"./id/index.d.ts": 24372,
	"./id/index.js": 47796,
	"./id/index.js.flow": 56768,
	"./id/package": 68110,
	"./id/package.json": 68110,
	"./index": 89477,
	"./index.js": 89477,
	"./index.js.flow": 56774,
	"./is": 78998,
	"./is/": 78998,
	"./is/_lib/formatDistance": 42938,
	"./is/_lib/formatDistance/": 42938,
	"./is/_lib/formatDistance/index": 42938,
	"./is/_lib/formatDistance/index.js": 42938,
	"./is/_lib/formatLong": 95079,
	"./is/_lib/formatLong/": 95079,
	"./is/_lib/formatLong/index": 95079,
	"./is/_lib/formatLong/index.js": 95079,
	"./is/_lib/formatRelative": 75434,
	"./is/_lib/formatRelative/": 75434,
	"./is/_lib/formatRelative/index": 75434,
	"./is/_lib/formatRelative/index.js": 75434,
	"./is/_lib/localize": 66245,
	"./is/_lib/localize/": 66245,
	"./is/_lib/localize/index": 66245,
	"./is/_lib/localize/index.js": 66245,
	"./is/_lib/match": 90032,
	"./is/_lib/match/": 90032,
	"./is/_lib/match/index": 90032,
	"./is/_lib/match/index.js": 90032,
	"./is/index": 6653,
	"./is/index.d.ts": 18255,
	"./is/index.js": 6653,
	"./is/index.js.flow": 10503,
	"./is/package": 64765,
	"./is/package.json": 64765,
	"./it": 18468,
	"./it-CH": 95551,
	"./it-CH/": 95551,
	"./it-CH/_lib/formatLong": 27034,
	"./it-CH/_lib/formatLong/": 27034,
	"./it-CH/_lib/formatLong/index": 27034,
	"./it-CH/_lib/formatLong/index.js": 27034,
	"./it-CH/index": 56563,
	"./it-CH/index.d.ts": 89398,
	"./it-CH/index.js": 56563,
	"./it-CH/index.js.flow": 67988,
	"./it-CH/package": 75055,
	"./it-CH/package.json": 75055,
	"./it/": 18468,
	"./it/_lib/formatDistance": 58249,
	"./it/_lib/formatDistance/": 58249,
	"./it/_lib/formatDistance/index": 58249,
	"./it/_lib/formatDistance/index.js": 58249,
	"./it/_lib/formatLong": 6311,
	"./it/_lib/formatLong/": 6311,
	"./it/_lib/formatLong/index": 6311,
	"./it/_lib/formatLong/index.js": 6311,
	"./it/_lib/formatRelative": 50170,
	"./it/_lib/formatRelative/": 50170,
	"./it/_lib/formatRelative/index": 50170,
	"./it/_lib/formatRelative/index.js": 50170,
	"./it/_lib/localize": 76895,
	"./it/_lib/localize/": 76895,
	"./it/_lib/localize/index": 76895,
	"./it/_lib/localize/index.js": 76895,
	"./it/_lib/match": 27722,
	"./it/_lib/match/": 27722,
	"./it/_lib/match/index": 27722,
	"./it/_lib/match/index.js": 27722,
	"./it/index": 46458,
	"./it/index.d.ts": 21583,
	"./it/index.js": 46458,
	"./it/index.js.flow": 13365,
	"./it/package": 17956,
	"./it/package.json": 17956,
	"./ja": 2889,
	"./ja-Hira": 71064,
	"./ja-Hira/": 71064,
	"./ja-Hira/_lib/formatDistance": 4957,
	"./ja-Hira/_lib/formatDistance/": 4957,
	"./ja-Hira/_lib/formatDistance/index": 4957,
	"./ja-Hira/_lib/formatDistance/index.js": 4957,
	"./ja-Hira/_lib/formatLong": 93161,
	"./ja-Hira/_lib/formatLong/": 93161,
	"./ja-Hira/_lib/formatLong/index": 93161,
	"./ja-Hira/_lib/formatLong/index.js": 93161,
	"./ja-Hira/_lib/formatRelative": 98290,
	"./ja-Hira/_lib/formatRelative/": 98290,
	"./ja-Hira/_lib/formatRelative/index": 98290,
	"./ja-Hira/_lib/formatRelative/index.js": 98290,
	"./ja-Hira/_lib/localize": 56626,
	"./ja-Hira/_lib/localize/": 56626,
	"./ja-Hira/_lib/localize/index": 56626,
	"./ja-Hira/_lib/localize/index.js": 56626,
	"./ja-Hira/_lib/match": 60764,
	"./ja-Hira/_lib/match/": 60764,
	"./ja-Hira/_lib/match/index": 60764,
	"./ja-Hira/_lib/match/index.js": 60764,
	"./ja-Hira/index": 14952,
	"./ja-Hira/index.d.ts": 86031,
	"./ja-Hira/index.js": 14952,
	"./ja-Hira/index.js.flow": 91520,
	"./ja-Hira/package": 71237,
	"./ja-Hira/package.json": 71237,
	"./ja/": 2889,
	"./ja/_lib/formatDistance": 61338,
	"./ja/_lib/formatDistance/": 61338,
	"./ja/_lib/formatDistance/index": 61338,
	"./ja/_lib/formatDistance/index.js": 61338,
	"./ja/_lib/formatLong": 93775,
	"./ja/_lib/formatLong/": 93775,
	"./ja/_lib/formatLong/index": 93775,
	"./ja/_lib/formatLong/index.js": 93775,
	"./ja/_lib/formatRelative": 59477,
	"./ja/_lib/formatRelative/": 59477,
	"./ja/_lib/formatRelative/index": 59477,
	"./ja/_lib/formatRelative/index.js": 59477,
	"./ja/_lib/localize": 20538,
	"./ja/_lib/localize/": 20538,
	"./ja/_lib/localize/index": 20538,
	"./ja/_lib/localize/index.js": 20538,
	"./ja/_lib/match": 23367,
	"./ja/_lib/match/": 23367,
	"./ja/_lib/match/index": 23367,
	"./ja/_lib/match/index.js": 23367,
	"./ja/index": 17971,
	"./ja/index.d.ts": 40237,
	"./ja/index.js": 17971,
	"./ja/index.js.flow": 67441,
	"./ja/package": 16321,
	"./ja/package.json": 16321,
	"./ka": 12823,
	"./ka/": 12823,
	"./ka/_lib/formatDistance": 48293,
	"./ka/_lib/formatDistance/": 48293,
	"./ka/_lib/formatDistance/index": 48293,
	"./ka/_lib/formatDistance/index.js": 48293,
	"./ka/_lib/formatLong": 60133,
	"./ka/_lib/formatLong/": 60133,
	"./ka/_lib/formatLong/index": 60133,
	"./ka/_lib/formatLong/index.js": 60133,
	"./ka/_lib/formatRelative": 33169,
	"./ka/_lib/formatRelative/": 33169,
	"./ka/_lib/formatRelative/index": 33169,
	"./ka/_lib/formatRelative/index.js": 33169,
	"./ka/_lib/localize": 15564,
	"./ka/_lib/localize/": 15564,
	"./ka/_lib/localize/index": 15564,
	"./ka/_lib/localize/index.js": 15564,
	"./ka/_lib/match": 44180,
	"./ka/_lib/match/": 44180,
	"./ka/_lib/match/index": 44180,
	"./ka/_lib/match/index.js": 44180,
	"./ka/index": 40656,
	"./ka/index.d.ts": 34530,
	"./ka/index.js": 40656,
	"./ka/index.js.flow": 33528,
	"./ka/package": 33300,
	"./ka/package.json": 33300,
	"./kk": 77710,
	"./kk/": 77710,
	"./kk/_lib/formatDistance": 13043,
	"./kk/_lib/formatDistance/": 13043,
	"./kk/_lib/formatDistance/index": 13043,
	"./kk/_lib/formatDistance/index.js": 13043,
	"./kk/_lib/formatLong": 73516,
	"./kk/_lib/formatLong/": 73516,
	"./kk/_lib/formatLong/index": 73516,
	"./kk/_lib/formatLong/index.js": 73516,
	"./kk/_lib/formatRelative": 96819,
	"./kk/_lib/formatRelative/": 96819,
	"./kk/_lib/formatRelative/index": 96819,
	"./kk/_lib/formatRelative/index.js": 96819,
	"./kk/_lib/localize": 69652,
	"./kk/_lib/localize/": 69652,
	"./kk/_lib/localize/index": 69652,
	"./kk/_lib/localize/index.js": 69652,
	"./kk/_lib/match": 10908,
	"./kk/_lib/match/": 10908,
	"./kk/_lib/match/index": 10908,
	"./kk/_lib/match/index.js": 10908,
	"./kk/index": 90488,
	"./kk/index.d.ts": 44894,
	"./kk/index.js": 90488,
	"./kk/index.js.flow": 59573,
	"./kk/package": 99671,
	"./kk/package.json": 99671,
	"./km": 24239,
	"./km/": 24239,
	"./km/_lib/formatDistance": 40111,
	"./km/_lib/formatDistance/": 40111,
	"./km/_lib/formatDistance/index": 40111,
	"./km/_lib/formatDistance/index.js": 40111,
	"./km/_lib/formatLong": 58780,
	"./km/_lib/formatLong/": 58780,
	"./km/_lib/formatLong/index": 58780,
	"./km/_lib/formatLong/index.js": 58780,
	"./km/_lib/formatRelative": 13468,
	"./km/_lib/formatRelative/": 13468,
	"./km/_lib/formatRelative/index": 13468,
	"./km/_lib/formatRelative/index.js": 13468,
	"./km/_lib/localize": 59578,
	"./km/_lib/localize/": 59578,
	"./km/_lib/localize/index": 59578,
	"./km/_lib/localize/index.js": 59578,
	"./km/_lib/match": 86396,
	"./km/_lib/match/": 86396,
	"./km/_lib/match/index": 86396,
	"./km/_lib/match/index.js": 86396,
	"./km/index": 84541,
	"./km/index.d.ts": 27506,
	"./km/index.js": 84541,
	"./km/index.js.flow": 37360,
	"./km/package": 10016,
	"./km/package.json": 10016,
	"./kn": 14443,
	"./kn/": 14443,
	"./kn/_lib/formatDistance": 35976,
	"./kn/_lib/formatDistance/": 35976,
	"./kn/_lib/formatDistance/index": 35976,
	"./kn/_lib/formatDistance/index.js": 35976,
	"./kn/_lib/formatLong": 26522,
	"./kn/_lib/formatLong/": 26522,
	"./kn/_lib/formatLong/index": 26522,
	"./kn/_lib/formatLong/index.js": 26522,
	"./kn/_lib/formatRelative": 43411,
	"./kn/_lib/formatRelative/": 43411,
	"./kn/_lib/formatRelative/index": 43411,
	"./kn/_lib/formatRelative/index.js": 43411,
	"./kn/_lib/localize": 48114,
	"./kn/_lib/localize/": 48114,
	"./kn/_lib/localize/index": 48114,
	"./kn/_lib/localize/index.js": 48114,
	"./kn/_lib/match": 62916,
	"./kn/_lib/match/": 62916,
	"./kn/_lib/match/index": 62916,
	"./kn/_lib/match/index.js": 62916,
	"./kn/index": 86486,
	"./kn/index.d.ts": 21242,
	"./kn/index.js": 86486,
	"./kn/index.js.flow": 63833,
	"./kn/package": 24124,
	"./kn/package.json": 24124,
	"./ko": 9000,
	"./ko/": 9000,
	"./ko/_lib/formatDistance": 47421,
	"./ko/_lib/formatDistance/": 47421,
	"./ko/_lib/formatDistance/index": 47421,
	"./ko/_lib/formatDistance/index.js": 47421,
	"./ko/_lib/formatLong": 12170,
	"./ko/_lib/formatLong/": 12170,
	"./ko/_lib/formatLong/index": 12170,
	"./ko/_lib/formatLong/index.js": 12170,
	"./ko/_lib/formatRelative": 63114,
	"./ko/_lib/formatRelative/": 63114,
	"./ko/_lib/formatRelative/index": 63114,
	"./ko/_lib/formatRelative/index.js": 63114,
	"./ko/_lib/localize": 3863,
	"./ko/_lib/localize/": 3863,
	"./ko/_lib/localize/index": 3863,
	"./ko/_lib/localize/index.js": 3863,
	"./ko/_lib/match": 72132,
	"./ko/_lib/match/": 72132,
	"./ko/_lib/match/index": 72132,
	"./ko/_lib/match/index.js": 72132,
	"./ko/index": 41542,
	"./ko/index.d.ts": 12653,
	"./ko/index.js": 41542,
	"./ko/index.js.flow": 82353,
	"./ko/package": 27682,
	"./ko/package.json": 27682,
	"./lb": 71707,
	"./lb/": 71707,
	"./lb/_lib/formatDistance": 52465,
	"./lb/_lib/formatDistance/": 52465,
	"./lb/_lib/formatDistance/index": 52465,
	"./lb/_lib/formatDistance/index.js": 52465,
	"./lb/_lib/formatLong": 60927,
	"./lb/_lib/formatLong/": 60927,
	"./lb/_lib/formatLong/index": 60927,
	"./lb/_lib/formatLong/index.js": 60927,
	"./lb/_lib/formatRelative": 25336,
	"./lb/_lib/formatRelative/": 25336,
	"./lb/_lib/formatRelative/index": 25336,
	"./lb/_lib/formatRelative/index.js": 25336,
	"./lb/_lib/localize": 49662,
	"./lb/_lib/localize/": 49662,
	"./lb/_lib/localize/index": 49662,
	"./lb/_lib/localize/index.js": 49662,
	"./lb/_lib/match": 45919,
	"./lb/_lib/match/": 45919,
	"./lb/_lib/match/index": 45919,
	"./lb/_lib/match/index.js": 45919,
	"./lb/index": 6737,
	"./lb/index.d.ts": 69158,
	"./lb/index.js": 6737,
	"./lb/index.js.flow": 27486,
	"./lb/package": 47689,
	"./lb/package.json": 47689,
	"./lt": 44003,
	"./lt/": 44003,
	"./lt/_lib/formatDistance": 63482,
	"./lt/_lib/formatDistance/": 63482,
	"./lt/_lib/formatDistance/index": 63482,
	"./lt/_lib/formatDistance/index.js": 63482,
	"./lt/_lib/formatLong": 80221,
	"./lt/_lib/formatLong/": 80221,
	"./lt/_lib/formatLong/index": 80221,
	"./lt/_lib/formatLong/index.js": 80221,
	"./lt/_lib/formatRelative": 4949,
	"./lt/_lib/formatRelative/": 4949,
	"./lt/_lib/formatRelative/index": 4949,
	"./lt/_lib/formatRelative/index.js": 4949,
	"./lt/_lib/localize": 37256,
	"./lt/_lib/localize/": 37256,
	"./lt/_lib/localize/index": 37256,
	"./lt/_lib/localize/index.js": 37256,
	"./lt/_lib/match": 3431,
	"./lt/_lib/match/": 3431,
	"./lt/_lib/match/index": 3431,
	"./lt/_lib/match/index.js": 3431,
	"./lt/index": 3765,
	"./lt/index.d.ts": 76289,
	"./lt/index.js": 3765,
	"./lt/index.js.flow": 2534,
	"./lt/package": 27954,
	"./lt/package.json": 27954,
	"./lv": 11851,
	"./lv/": 11851,
	"./lv/_lib/formatDistance": 1809,
	"./lv/_lib/formatDistance/": 1809,
	"./lv/_lib/formatDistance/index": 1809,
	"./lv/_lib/formatDistance/index.js": 1809,
	"./lv/_lib/formatLong": 352,
	"./lv/_lib/formatLong/": 352,
	"./lv/_lib/formatLong/index": 352,
	"./lv/_lib/formatLong/index.js": 352,
	"./lv/_lib/formatRelative": 81658,
	"./lv/_lib/formatRelative/": 81658,
	"./lv/_lib/formatRelative/index": 81658,
	"./lv/_lib/formatRelative/index.js": 81658,
	"./lv/_lib/localize": 46190,
	"./lv/_lib/localize/": 46190,
	"./lv/_lib/localize/index": 46190,
	"./lv/_lib/localize/index.js": 46190,
	"./lv/_lib/match": 82316,
	"./lv/_lib/match/": 82316,
	"./lv/_lib/match/index": 82316,
	"./lv/_lib/match/index.js": 82316,
	"./lv/index": 93719,
	"./lv/index.d.ts": 77691,
	"./lv/index.js": 93719,
	"./lv/index.js.flow": 48693,
	"./lv/package": 12472,
	"./lv/package.json": 12472,
	"./mk": 9079,
	"./mk/": 9079,
	"./mk/_lib/formatDistance": 82629,
	"./mk/_lib/formatDistance/": 82629,
	"./mk/_lib/formatDistance/index": 82629,
	"./mk/_lib/formatDistance/index.js": 82629,
	"./mk/_lib/formatLong": 43584,
	"./mk/_lib/formatLong/": 43584,
	"./mk/_lib/formatLong/index": 43584,
	"./mk/_lib/formatLong/index.js": 43584,
	"./mk/_lib/formatRelative": 92828,
	"./mk/_lib/formatRelative/": 92828,
	"./mk/_lib/formatRelative/index": 92828,
	"./mk/_lib/formatRelative/index.js": 92828,
	"./mk/_lib/localize": 7142,
	"./mk/_lib/localize/": 7142,
	"./mk/_lib/localize/index": 7142,
	"./mk/_lib/localize/index.js": 7142,
	"./mk/_lib/match": 77358,
	"./mk/_lib/match/": 77358,
	"./mk/_lib/match/index": 77358,
	"./mk/_lib/match/index.js": 77358,
	"./mk/index": 79666,
	"./mk/index.d.ts": 22725,
	"./mk/index.js": 79666,
	"./mk/index.js.flow": 24979,
	"./mk/package": 99945,
	"./mk/package.json": 99945,
	"./mn": 74845,
	"./mn/": 74845,
	"./mn/_lib/formatDistance": 78212,
	"./mn/_lib/formatDistance/": 78212,
	"./mn/_lib/formatDistance/index": 78212,
	"./mn/_lib/formatDistance/index.js": 78212,
	"./mn/_lib/formatLong": 1544,
	"./mn/_lib/formatLong/": 1544,
	"./mn/_lib/formatLong/index": 1544,
	"./mn/_lib/formatLong/index.js": 1544,
	"./mn/_lib/formatRelative": 61014,
	"./mn/_lib/formatRelative/": 61014,
	"./mn/_lib/formatRelative/index": 61014,
	"./mn/_lib/formatRelative/index.js": 61014,
	"./mn/_lib/localize": 68286,
	"./mn/_lib/localize/": 68286,
	"./mn/_lib/localize/index": 68286,
	"./mn/_lib/localize/index.js": 68286,
	"./mn/_lib/match": 80752,
	"./mn/_lib/match/": 80752,
	"./mn/_lib/match/index": 80752,
	"./mn/_lib/match/index.js": 80752,
	"./mn/index": 1256,
	"./mn/index.d.ts": 80516,
	"./mn/index.js": 1256,
	"./mn/index.js.flow": 5279,
	"./mn/package": 77476,
	"./mn/package.json": 77476,
	"./ms": 48807,
	"./ms/": 48807,
	"./ms/_lib/formatDistance": 83517,
	"./ms/_lib/formatDistance/": 83517,
	"./ms/_lib/formatDistance/index": 83517,
	"./ms/_lib/formatDistance/index.js": 83517,
	"./ms/_lib/formatLong": 65584,
	"./ms/_lib/formatLong/": 65584,
	"./ms/_lib/formatLong/index": 65584,
	"./ms/_lib/formatLong/index.js": 65584,
	"./ms/_lib/formatRelative": 57209,
	"./ms/_lib/formatRelative/": 57209,
	"./ms/_lib/formatRelative/index": 57209,
	"./ms/_lib/formatRelative/index.js": 57209,
	"./ms/_lib/localize": 82367,
	"./ms/_lib/localize/": 82367,
	"./ms/_lib/localize/index": 82367,
	"./ms/_lib/localize/index.js": 82367,
	"./ms/_lib/match": 7679,
	"./ms/_lib/match/": 7679,
	"./ms/_lib/match/index": 7679,
	"./ms/_lib/match/index.js": 7679,
	"./ms/index": 4358,
	"./ms/index.d.ts": 43205,
	"./ms/index.js": 4358,
	"./ms/index.js.flow": 62042,
	"./ms/package": 17333,
	"./ms/package.json": 17333,
	"./mt": 85321,
	"./mt/": 85321,
	"./mt/_lib/formatDistance": 67635,
	"./mt/_lib/formatDistance/": 67635,
	"./mt/_lib/formatDistance/index": 67635,
	"./mt/_lib/formatDistance/index.js": 67635,
	"./mt/_lib/formatLong": 92549,
	"./mt/_lib/formatLong/": 92549,
	"./mt/_lib/formatLong/index": 92549,
	"./mt/_lib/formatLong/index.js": 92549,
	"./mt/_lib/formatRelative": 49983,
	"./mt/_lib/formatRelative/": 49983,
	"./mt/_lib/formatRelative/index": 49983,
	"./mt/_lib/formatRelative/index.js": 49983,
	"./mt/_lib/localize": 1039,
	"./mt/_lib/localize/": 1039,
	"./mt/_lib/localize/index": 1039,
	"./mt/_lib/localize/index.js": 1039,
	"./mt/_lib/match": 52098,
	"./mt/_lib/match/": 52098,
	"./mt/_lib/match/index": 52098,
	"./mt/_lib/match/index.js": 52098,
	"./mt/index": 61949,
	"./mt/index.d.ts": 34314,
	"./mt/index.js": 61949,
	"./mt/index.js.flow": 27704,
	"./mt/package": 64791,
	"./mt/package.json": 64791,
	"./nb": 76768,
	"./nb/": 76768,
	"./nb/_lib/formatDistance": 83511,
	"./nb/_lib/formatDistance/": 83511,
	"./nb/_lib/formatDistance/index": 83511,
	"./nb/_lib/formatDistance/index.js": 83511,
	"./nb/_lib/formatLong": 28529,
	"./nb/_lib/formatLong/": 28529,
	"./nb/_lib/formatLong/index": 28529,
	"./nb/_lib/formatLong/index.js": 28529,
	"./nb/_lib/formatRelative": 98881,
	"./nb/_lib/formatRelative/": 98881,
	"./nb/_lib/formatRelative/index": 98881,
	"./nb/_lib/formatRelative/index.js": 98881,
	"./nb/_lib/localize": 48260,
	"./nb/_lib/localize/": 48260,
	"./nb/_lib/localize/index": 48260,
	"./nb/_lib/localize/index.js": 48260,
	"./nb/_lib/match": 37783,
	"./nb/_lib/match/": 37783,
	"./nb/_lib/match/index": 37783,
	"./nb/_lib/match/index.js": 37783,
	"./nb/index": 42340,
	"./nb/index.d.ts": 60586,
	"./nb/index.js": 42340,
	"./nb/index.js.flow": 4513,
	"./nb/package": 85078,
	"./nb/package.json": 85078,
	"./nl": 7376,
	"./nl-BE": 39934,
	"./nl-BE/": 39934,
	"./nl-BE/_lib/formatDistance": 25200,
	"./nl-BE/_lib/formatDistance/": 25200,
	"./nl-BE/_lib/formatDistance/index": 25200,
	"./nl-BE/_lib/formatDistance/index.js": 25200,
	"./nl-BE/_lib/formatLong": 35382,
	"./nl-BE/_lib/formatLong/": 35382,
	"./nl-BE/_lib/formatLong/index": 35382,
	"./nl-BE/_lib/formatLong/index.js": 35382,
	"./nl-BE/_lib/formatRelative": 5824,
	"./nl-BE/_lib/formatRelative/": 5824,
	"./nl-BE/_lib/formatRelative/index": 5824,
	"./nl-BE/_lib/formatRelative/index.js": 5824,
	"./nl-BE/_lib/localize": 94121,
	"./nl-BE/_lib/localize/": 94121,
	"./nl-BE/_lib/localize/index": 94121,
	"./nl-BE/_lib/localize/index.js": 94121,
	"./nl-BE/_lib/match": 41577,
	"./nl-BE/_lib/match/": 41577,
	"./nl-BE/_lib/match/index": 41577,
	"./nl-BE/_lib/match/index.js": 41577,
	"./nl-BE/index": 15359,
	"./nl-BE/index.d.ts": 23018,
	"./nl-BE/index.js": 15359,
	"./nl-BE/index.js.flow": 64505,
	"./nl-BE/package": 14060,
	"./nl-BE/package.json": 14060,
	"./nl/": 7376,
	"./nl/_lib/formatDistance": 63786,
	"./nl/_lib/formatDistance/": 63786,
	"./nl/_lib/formatDistance/index": 63786,
	"./nl/_lib/formatDistance/index.js": 63786,
	"./nl/_lib/formatLong": 82740,
	"./nl/_lib/formatLong/": 82740,
	"./nl/_lib/formatLong/index": 82740,
	"./nl/_lib/formatLong/index.js": 82740,
	"./nl/_lib/formatRelative": 6665,
	"./nl/_lib/formatRelative/": 6665,
	"./nl/_lib/formatRelative/index": 6665,
	"./nl/_lib/formatRelative/index.js": 6665,
	"./nl/_lib/localize": 73677,
	"./nl/_lib/localize/": 73677,
	"./nl/_lib/localize/index": 73677,
	"./nl/_lib/localize/index.js": 73677,
	"./nl/_lib/match": 20309,
	"./nl/_lib/match/": 20309,
	"./nl/_lib/match/index": 20309,
	"./nl/_lib/match/index.js": 20309,
	"./nl/index": 9214,
	"./nl/index.d.ts": 84365,
	"./nl/index.js": 9214,
	"./nl/index.js.flow": 76623,
	"./nl/package": 68666,
	"./nl/package.json": 68666,
	"./nn": 23138,
	"./nn/": 23138,
	"./nn/_lib/formatDistance": 63994,
	"./nn/_lib/formatDistance/": 63994,
	"./nn/_lib/formatDistance/index": 63994,
	"./nn/_lib/formatDistance/index.js": 63994,
	"./nn/_lib/formatLong": 73159,
	"./nn/_lib/formatLong/": 73159,
	"./nn/_lib/formatLong/index": 73159,
	"./nn/_lib/formatLong/index.js": 73159,
	"./nn/_lib/formatRelative": 63004,
	"./nn/_lib/formatRelative/": 63004,
	"./nn/_lib/formatRelative/index": 63004,
	"./nn/_lib/formatRelative/index.js": 63004,
	"./nn/_lib/localize": 71321,
	"./nn/_lib/localize/": 71321,
	"./nn/_lib/localize/index": 71321,
	"./nn/_lib/localize/index.js": 71321,
	"./nn/_lib/match": 64123,
	"./nn/_lib/match/": 64123,
	"./nn/_lib/match/index": 64123,
	"./nn/_lib/match/index.js": 64123,
	"./nn/index": 32531,
	"./nn/index.d.ts": 17538,
	"./nn/index.js": 32531,
	"./nn/index.js.flow": 33857,
	"./nn/package": 83697,
	"./nn/package.json": 83697,
	"./oc": 39603,
	"./oc/": 39603,
	"./oc/_lib/formatDistance": 33291,
	"./oc/_lib/formatDistance/": 33291,
	"./oc/_lib/formatDistance/index": 33291,
	"./oc/_lib/formatDistance/index.js": 33291,
	"./oc/_lib/formatLong": 73476,
	"./oc/_lib/formatLong/": 73476,
	"./oc/_lib/formatLong/index": 73476,
	"./oc/_lib/formatLong/index.js": 73476,
	"./oc/_lib/formatRelative": 85432,
	"./oc/_lib/formatRelative/": 85432,
	"./oc/_lib/formatRelative/index": 85432,
	"./oc/_lib/formatRelative/index.js": 85432,
	"./oc/_lib/localize": 65913,
	"./oc/_lib/localize/": 65913,
	"./oc/_lib/localize/index": 65913,
	"./oc/_lib/localize/index.js": 65913,
	"./oc/_lib/match": 2029,
	"./oc/_lib/match/": 2029,
	"./oc/_lib/match/index": 2029,
	"./oc/_lib/match/index.js": 2029,
	"./oc/index": 14659,
	"./oc/index.d.ts": 77009,
	"./oc/index.js": 14659,
	"./oc/index.js.flow": 98687,
	"./oc/package": 3569,
	"./oc/package.json": 3569,
	"./package": 81946,
	"./package.json": 81946,
	"./pl": 64345,
	"./pl/": 64345,
	"./pl/_lib/formatDistance": 36734,
	"./pl/_lib/formatDistance/": 36734,
	"./pl/_lib/formatDistance/index": 36734,
	"./pl/_lib/formatDistance/index.js": 36734,
	"./pl/_lib/formatLong": 11098,
	"./pl/_lib/formatLong/": 11098,
	"./pl/_lib/formatLong/index": 11098,
	"./pl/_lib/formatLong/index.js": 11098,
	"./pl/_lib/formatRelative": 80903,
	"./pl/_lib/formatRelative/": 80903,
	"./pl/_lib/formatRelative/index": 80903,
	"./pl/_lib/formatRelative/index.js": 80903,
	"./pl/_lib/localize": 62266,
	"./pl/_lib/localize/": 62266,
	"./pl/_lib/localize/index": 62266,
	"./pl/_lib/localize/index.js": 62266,
	"./pl/_lib/match": 51983,
	"./pl/_lib/match/": 51983,
	"./pl/_lib/match/index": 51983,
	"./pl/_lib/match/index.js": 51983,
	"./pl/index": 40710,
	"./pl/index.d.ts": 42066,
	"./pl/index.js": 40710,
	"./pl/index.js.flow": 84123,
	"./pl/package": 8127,
	"./pl/package.json": 8127,
	"./pt": 30037,
	"./pt-BR": 80011,
	"./pt-BR/": 80011,
	"./pt-BR/_lib/formatDistance": 4674,
	"./pt-BR/_lib/formatDistance/": 4674,
	"./pt-BR/_lib/formatDistance/index": 4674,
	"./pt-BR/_lib/formatDistance/index.js": 4674,
	"./pt-BR/_lib/formatLong": 66561,
	"./pt-BR/_lib/formatLong/": 66561,
	"./pt-BR/_lib/formatLong/index": 66561,
	"./pt-BR/_lib/formatLong/index.js": 66561,
	"./pt-BR/_lib/formatRelative": 78546,
	"./pt-BR/_lib/formatRelative/": 78546,
	"./pt-BR/_lib/formatRelative/index": 78546,
	"./pt-BR/_lib/formatRelative/index.js": 78546,
	"./pt-BR/_lib/localize": 37982,
	"./pt-BR/_lib/localize/": 37982,
	"./pt-BR/_lib/localize/index": 37982,
	"./pt-BR/_lib/localize/index.js": 37982,
	"./pt-BR/_lib/match": 36229,
	"./pt-BR/_lib/match/": 36229,
	"./pt-BR/_lib/match/index": 36229,
	"./pt-BR/_lib/match/index.js": 36229,
	"./pt-BR/index": 17635,
	"./pt-BR/index.d.ts": 29253,
	"./pt-BR/index.js": 17635,
	"./pt-BR/index.js.flow": 23537,
	"./pt-BR/package": 84856,
	"./pt-BR/package.json": 84856,
	"./pt/": 30037,
	"./pt/_lib/formatDistance": 17021,
	"./pt/_lib/formatDistance/": 17021,
	"./pt/_lib/formatDistance/index": 17021,
	"./pt/_lib/formatDistance/index.js": 17021,
	"./pt/_lib/formatLong": 86700,
	"./pt/_lib/formatLong/": 86700,
	"./pt/_lib/formatLong/index": 86700,
	"./pt/_lib/formatLong/index.js": 86700,
	"./pt/_lib/formatRelative": 9872,
	"./pt/_lib/formatRelative/": 9872,
	"./pt/_lib/formatRelative/index": 9872,
	"./pt/_lib/formatRelative/index.js": 9872,
	"./pt/_lib/localize": 52127,
	"./pt/_lib/localize/": 52127,
	"./pt/_lib/localize/index": 52127,
	"./pt/_lib/localize/index.js": 52127,
	"./pt/_lib/match": 6878,
	"./pt/_lib/match/": 6878,
	"./pt/_lib/match/index": 6878,
	"./pt/_lib/match/index.js": 6878,
	"./pt/index": 43653,
	"./pt/index.d.ts": 3422,
	"./pt/index.js": 43653,
	"./pt/index.js.flow": 38446,
	"./pt/package": 15104,
	"./pt/package.json": 15104,
	"./ro": 85369,
	"./ro/": 85369,
	"./ro/_lib/formatDistance": 24693,
	"./ro/_lib/formatDistance/": 24693,
	"./ro/_lib/formatDistance/index": 24693,
	"./ro/_lib/formatDistance/index.js": 24693,
	"./ro/_lib/formatLong": 26222,
	"./ro/_lib/formatLong/": 26222,
	"./ro/_lib/formatLong/index": 26222,
	"./ro/_lib/formatLong/index.js": 26222,
	"./ro/_lib/formatRelative": 9324,
	"./ro/_lib/formatRelative/": 9324,
	"./ro/_lib/formatRelative/index": 9324,
	"./ro/_lib/formatRelative/index.js": 9324,
	"./ro/_lib/localize": 49120,
	"./ro/_lib/localize/": 49120,
	"./ro/_lib/localize/index": 49120,
	"./ro/_lib/localize/index.js": 49120,
	"./ro/_lib/match": 41850,
	"./ro/_lib/match/": 41850,
	"./ro/_lib/match/index": 41850,
	"./ro/_lib/match/index.js": 41850,
	"./ro/index": 62281,
	"./ro/index.d.ts": 3049,
	"./ro/index.js": 62281,
	"./ro/index.js.flow": 39681,
	"./ro/package": 80242,
	"./ro/package.json": 80242,
	"./ru": 69763,
	"./ru/": 69763,
	"./ru/_lib/formatDistance": 19849,
	"./ru/_lib/formatDistance/": 19849,
	"./ru/_lib/formatDistance/index": 19849,
	"./ru/_lib/formatDistance/index.js": 19849,
	"./ru/_lib/formatLong": 24489,
	"./ru/_lib/formatLong/": 24489,
	"./ru/_lib/formatLong/index": 24489,
	"./ru/_lib/formatLong/index.js": 24489,
	"./ru/_lib/formatRelative": 46937,
	"./ru/_lib/formatRelative/": 46937,
	"./ru/_lib/formatRelative/index": 46937,
	"./ru/_lib/formatRelative/index.js": 46937,
	"./ru/_lib/localize": 94617,
	"./ru/_lib/localize/": 94617,
	"./ru/_lib/localize/index": 94617,
	"./ru/_lib/localize/index.js": 94617,
	"./ru/_lib/match": 44399,
	"./ru/_lib/match/": 44399,
	"./ru/_lib/match/index": 44399,
	"./ru/_lib/match/index.js": 44399,
	"./ru/index": 19536,
	"./ru/index.d.ts": 31097,
	"./ru/index.js": 19536,
	"./ru/index.js.flow": 15581,
	"./ru/package": 48827,
	"./ru/package.json": 48827,
	"./sk": 8188,
	"./sk/": 8188,
	"./sk/_lib/formatDistance": 36427,
	"./sk/_lib/formatDistance/": 36427,
	"./sk/_lib/formatDistance/index": 36427,
	"./sk/_lib/formatDistance/index.js": 36427,
	"./sk/_lib/formatLong": 51784,
	"./sk/_lib/formatLong/": 51784,
	"./sk/_lib/formatLong/index": 51784,
	"./sk/_lib/formatLong/index.js": 51784,
	"./sk/_lib/formatRelative": 34599,
	"./sk/_lib/formatRelative/": 34599,
	"./sk/_lib/formatRelative/index": 34599,
	"./sk/_lib/formatRelative/index.js": 34599,
	"./sk/_lib/localize": 9224,
	"./sk/_lib/localize/": 9224,
	"./sk/_lib/localize/index": 9224,
	"./sk/_lib/localize/index.js": 9224,
	"./sk/_lib/match": 79908,
	"./sk/_lib/match/": 79908,
	"./sk/_lib/match/index": 79908,
	"./sk/_lib/match/index.js": 79908,
	"./sk/index": 28824,
	"./sk/index.d.ts": 83047,
	"./sk/index.js": 28824,
	"./sk/index.js.flow": 86741,
	"./sk/package": 98068,
	"./sk/package.json": 98068,
	"./sl": 66669,
	"./sl/": 66669,
	"./sl/_lib/formatDistance": 6002,
	"./sl/_lib/formatDistance/": 6002,
	"./sl/_lib/formatDistance/index": 6002,
	"./sl/_lib/formatDistance/index.js": 6002,
	"./sl/_lib/formatLong": 14217,
	"./sl/_lib/formatLong/": 14217,
	"./sl/_lib/formatLong/index": 14217,
	"./sl/_lib/formatLong/index.js": 14217,
	"./sl/_lib/formatRelative": 23182,
	"./sl/_lib/formatRelative/": 23182,
	"./sl/_lib/formatRelative/index": 23182,
	"./sl/_lib/formatRelative/index.js": 23182,
	"./sl/_lib/localize": 64371,
	"./sl/_lib/localize/": 64371,
	"./sl/_lib/localize/index": 64371,
	"./sl/_lib/localize/index.js": 64371,
	"./sl/_lib/match": 13367,
	"./sl/_lib/match/": 13367,
	"./sl/_lib/match/index": 13367,
	"./sl/_lib/match/index.js": 13367,
	"./sl/index": 56235,
	"./sl/index.d.ts": 25941,
	"./sl/index.js": 56235,
	"./sl/index.js.flow": 26464,
	"./sl/package": 38945,
	"./sl/package.json": 38945,
	"./sq": 94135,
	"./sq/": 94135,
	"./sq/_lib/formatDistance": 58257,
	"./sq/_lib/formatDistance/": 58257,
	"./sq/_lib/formatDistance/index": 58257,
	"./sq/_lib/formatDistance/index.js": 58257,
	"./sq/_lib/formatLong": 62298,
	"./sq/_lib/formatLong/": 62298,
	"./sq/_lib/formatLong/index": 62298,
	"./sq/_lib/formatLong/index.js": 62298,
	"./sq/_lib/formatRelative": 9348,
	"./sq/_lib/formatRelative/": 9348,
	"./sq/_lib/formatRelative/index": 9348,
	"./sq/_lib/formatRelative/index.js": 9348,
	"./sq/_lib/localize": 73762,
	"./sq/_lib/localize/": 73762,
	"./sq/_lib/localize/index": 73762,
	"./sq/_lib/localize/index.js": 73762,
	"./sq/_lib/match": 91744,
	"./sq/_lib/match/": 91744,
	"./sq/_lib/match/index": 91744,
	"./sq/_lib/match/index.js": 91744,
	"./sq/index": 72667,
	"./sq/index.d.ts": 33625,
	"./sq/index.js": 72667,
	"./sq/index.js.flow": 19361,
	"./sq/package": 70459,
	"./sq/package.json": 70459,
	"./sr": 37188,
	"./sr-Latn": 22409,
	"./sr-Latn/": 22409,
	"./sr-Latn/_lib/formatDistance": 75669,
	"./sr-Latn/_lib/formatDistance/": 75669,
	"./sr-Latn/_lib/formatDistance/index": 75669,
	"./sr-Latn/_lib/formatDistance/index.js": 75669,
	"./sr-Latn/_lib/formatLong": 12189,
	"./sr-Latn/_lib/formatLong/": 12189,
	"./sr-Latn/_lib/formatLong/index": 12189,
	"./sr-Latn/_lib/formatLong/index.js": 12189,
	"./sr-Latn/_lib/formatRelative": 18993,
	"./sr-Latn/_lib/formatRelative/": 18993,
	"./sr-Latn/_lib/formatRelative/index": 18993,
	"./sr-Latn/_lib/formatRelative/index.js": 18993,
	"./sr-Latn/_lib/localize": 86762,
	"./sr-Latn/_lib/localize/": 86762,
	"./sr-Latn/_lib/localize/index": 86762,
	"./sr-Latn/_lib/localize/index.js": 86762,
	"./sr-Latn/_lib/match": 7143,
	"./sr-Latn/_lib/match/": 7143,
	"./sr-Latn/_lib/match/index": 7143,
	"./sr-Latn/_lib/match/index.js": 7143,
	"./sr-Latn/index": 70927,
	"./sr-Latn/index.d.ts": 68755,
	"./sr-Latn/index.js": 70927,
	"./sr-Latn/index.js.flow": 95974,
	"./sr-Latn/package": 51278,
	"./sr-Latn/package.json": 51278,
	"./sr/": 37188,
	"./sr/_lib/formatDistance": 73527,
	"./sr/_lib/formatDistance/": 73527,
	"./sr/_lib/formatDistance/index": 73527,
	"./sr/_lib/formatDistance/index.js": 73527,
	"./sr/_lib/formatLong": 77669,
	"./sr/_lib/formatLong/": 77669,
	"./sr/_lib/formatLong/index": 77669,
	"./sr/_lib/formatLong/index.js": 77669,
	"./sr/_lib/formatRelative": 28639,
	"./sr/_lib/formatRelative/": 28639,
	"./sr/_lib/formatRelative/index": 28639,
	"./sr/_lib/formatRelative/index.js": 28639,
	"./sr/_lib/localize": 9291,
	"./sr/_lib/localize/": 9291,
	"./sr/_lib/localize/index": 9291,
	"./sr/_lib/localize/index.js": 9291,
	"./sr/_lib/match": 46795,
	"./sr/_lib/match/": 46795,
	"./sr/_lib/match/index": 46795,
	"./sr/_lib/match/index.js": 46795,
	"./sr/index": 65866,
	"./sr/index.d.ts": 48813,
	"./sr/index.js": 65866,
	"./sr/index.js.flow": 4879,
	"./sr/package": 99061,
	"./sr/package.json": 99061,
	"./sv": 52892,
	"./sv/": 52892,
	"./sv/_lib/formatDistance": 68765,
	"./sv/_lib/formatDistance/": 68765,
	"./sv/_lib/formatDistance/index": 68765,
	"./sv/_lib/formatDistance/index.js": 68765,
	"./sv/_lib/formatLong": 407,
	"./sv/_lib/formatLong/": 407,
	"./sv/_lib/formatLong/index": 407,
	"./sv/_lib/formatLong/index.js": 407,
	"./sv/_lib/formatRelative": 83813,
	"./sv/_lib/formatRelative/": 83813,
	"./sv/_lib/formatRelative/index": 83813,
	"./sv/_lib/formatRelative/index.js": 83813,
	"./sv/_lib/localize": 27548,
	"./sv/_lib/localize/": 27548,
	"./sv/_lib/localize/index": 27548,
	"./sv/_lib/localize/index.js": 27548,
	"./sv/_lib/match": 86159,
	"./sv/_lib/match/": 86159,
	"./sv/_lib/match/index": 86159,
	"./sv/_lib/match/index.js": 86159,
	"./sv/index": 25635,
	"./sv/index.d.ts": 69507,
	"./sv/index.js": 25635,
	"./sv/index.js.flow": 13075,
	"./sv/package": 73958,
	"./sv/package.json": 73958,
	"./ta": 21826,
	"./ta/": 21826,
	"./ta/_lib/formatDistance": 80848,
	"./ta/_lib/formatDistance/": 80848,
	"./ta/_lib/formatDistance/index": 80848,
	"./ta/_lib/formatDistance/index.js": 80848,
	"./ta/_lib/formatLong": 1876,
	"./ta/_lib/formatLong/": 1876,
	"./ta/_lib/formatLong/index": 1876,
	"./ta/_lib/formatLong/index.js": 1876,
	"./ta/_lib/formatRelative": 10147,
	"./ta/_lib/formatRelative/": 10147,
	"./ta/_lib/formatRelative/index": 10147,
	"./ta/_lib/formatRelative/index.js": 10147,
	"./ta/_lib/localize": 49321,
	"./ta/_lib/localize/": 49321,
	"./ta/_lib/localize/index": 49321,
	"./ta/_lib/localize/index.js": 49321,
	"./ta/_lib/match": 80810,
	"./ta/_lib/match/": 80810,
	"./ta/_lib/match/index": 80810,
	"./ta/_lib/match/index.js": 80810,
	"./ta/index": 86783,
	"./ta/index.d.ts": 79781,
	"./ta/index.js": 86783,
	"./ta/index.js.flow": 16899,
	"./ta/package": 11176,
	"./ta/package.json": 11176,
	"./te": 26465,
	"./te/": 26465,
	"./te/_lib/formatDistance": 6890,
	"./te/_lib/formatDistance/": 6890,
	"./te/_lib/formatDistance/index": 6890,
	"./te/_lib/formatDistance/index.js": 6890,
	"./te/_lib/formatLong": 35635,
	"./te/_lib/formatLong/": 35635,
	"./te/_lib/formatLong/index": 35635,
	"./te/_lib/formatLong/index.js": 35635,
	"./te/_lib/formatRelative": 3644,
	"./te/_lib/formatRelative/": 3644,
	"./te/_lib/formatRelative/index": 3644,
	"./te/_lib/formatRelative/index.js": 3644,
	"./te/_lib/localize": 26136,
	"./te/_lib/localize/": 26136,
	"./te/_lib/localize/index": 26136,
	"./te/_lib/localize/index.js": 26136,
	"./te/_lib/match": 84493,
	"./te/_lib/match/": 84493,
	"./te/_lib/match/index": 84493,
	"./te/_lib/match/index.js": 84493,
	"./te/index": 68157,
	"./te/index.d.ts": 91009,
	"./te/index.js": 68157,
	"./te/index.js.flow": 23045,
	"./te/package": 41093,
	"./te/package.json": 41093,
	"./th": 23404,
	"./th/": 23404,
	"./th/_lib/formatDistance": 74191,
	"./th/_lib/formatDistance/": 74191,
	"./th/_lib/formatDistance/index": 74191,
	"./th/_lib/formatDistance/index.js": 74191,
	"./th/_lib/formatLong": 85008,
	"./th/_lib/formatLong/": 85008,
	"./th/_lib/formatLong/index": 85008,
	"./th/_lib/formatLong/index.js": 85008,
	"./th/_lib/formatRelative": 28293,
	"./th/_lib/formatRelative/": 28293,
	"./th/_lib/formatRelative/index": 28293,
	"./th/_lib/formatRelative/index.js": 28293,
	"./th/_lib/localize": 93533,
	"./th/_lib/localize/": 93533,
	"./th/_lib/localize/index": 93533,
	"./th/_lib/localize/index.js": 93533,
	"./th/_lib/match": 3405,
	"./th/_lib/match/": 3405,
	"./th/_lib/match/index": 3405,
	"./th/_lib/match/index.js": 3405,
	"./th/index": 72065,
	"./th/index.d.ts": 15921,
	"./th/index.js": 72065,
	"./th/index.js.flow": 40378,
	"./th/package": 80721,
	"./th/package.json": 80721,
	"./tr": 66108,
	"./tr/": 66108,
	"./tr/_lib/formatDistance": 31839,
	"./tr/_lib/formatDistance/": 31839,
	"./tr/_lib/formatDistance/index": 31839,
	"./tr/_lib/formatDistance/index.js": 31839,
	"./tr/_lib/formatLong": 39692,
	"./tr/_lib/formatLong/": 39692,
	"./tr/_lib/formatLong/index": 39692,
	"./tr/_lib/formatLong/index.js": 39692,
	"./tr/_lib/formatRelative": 94851,
	"./tr/_lib/formatRelative/": 94851,
	"./tr/_lib/formatRelative/index": 94851,
	"./tr/_lib/formatRelative/index.js": 94851,
	"./tr/_lib/localize": 31601,
	"./tr/_lib/localize/": 31601,
	"./tr/_lib/localize/index": 31601,
	"./tr/_lib/localize/index.js": 31601,
	"./tr/_lib/match": 91795,
	"./tr/_lib/match/": 91795,
	"./tr/_lib/match/index": 91795,
	"./tr/_lib/match/index.js": 91795,
	"./tr/index": 10944,
	"./tr/index.d.ts": 51534,
	"./tr/index.js": 10944,
	"./tr/index.js.flow": 94077,
	"./tr/package": 71501,
	"./tr/package.json": 71501,
	"./types": 40675,
	"./types.js": 40675,
	"./ug": 37861,
	"./ug/": 37861,
	"./ug/_lib/formatDistance": 6864,
	"./ug/_lib/formatDistance/": 6864,
	"./ug/_lib/formatDistance/index": 6864,
	"./ug/_lib/formatDistance/index.js": 6864,
	"./ug/_lib/formatLong": 99397,
	"./ug/_lib/formatLong/": 99397,
	"./ug/_lib/formatLong/index": 99397,
	"./ug/_lib/formatLong/index.js": 99397,
	"./ug/_lib/formatRelative": 99121,
	"./ug/_lib/formatRelative/": 99121,
	"./ug/_lib/formatRelative/index": 99121,
	"./ug/_lib/formatRelative/index.js": 99121,
	"./ug/_lib/localize": 11121,
	"./ug/_lib/localize/": 11121,
	"./ug/_lib/localize/index": 11121,
	"./ug/_lib/localize/index.js": 11121,
	"./ug/_lib/match": 29835,
	"./ug/_lib/match/": 29835,
	"./ug/_lib/match/index": 29835,
	"./ug/_lib/match/index.js": 29835,
	"./ug/index": 11639,
	"./ug/index.d.ts": 18299,
	"./ug/index.js": 11639,
	"./ug/index.js.flow": 26251,
	"./ug/package": 73101,
	"./ug/package.json": 73101,
	"./uk": 59879,
	"./uk/": 59879,
	"./uk/_lib/formatDistance": 21324,
	"./uk/_lib/formatDistance/": 21324,
	"./uk/_lib/formatDistance/index": 21324,
	"./uk/_lib/formatDistance/index.js": 21324,
	"./uk/_lib/formatLong": 29282,
	"./uk/_lib/formatLong/": 29282,
	"./uk/_lib/formatLong/index": 29282,
	"./uk/_lib/formatLong/index.js": 29282,
	"./uk/_lib/formatRelative": 79446,
	"./uk/_lib/formatRelative/": 79446,
	"./uk/_lib/formatRelative/index": 79446,
	"./uk/_lib/formatRelative/index.js": 79446,
	"./uk/_lib/localize": 7343,
	"./uk/_lib/localize/": 7343,
	"./uk/_lib/localize/index": 7343,
	"./uk/_lib/localize/index.js": 7343,
	"./uk/_lib/match": 3651,
	"./uk/_lib/match/": 3651,
	"./uk/_lib/match/index": 3651,
	"./uk/_lib/match/index.js": 3651,
	"./uk/index": 2312,
	"./uk/index.d.ts": 90835,
	"./uk/index.js": 2312,
	"./uk/index.js.flow": 1003,
	"./uk/package": 75617,
	"./uk/package.json": 75617,
	"./uz": 91990,
	"./uz-Cyrl": 45452,
	"./uz-Cyrl/": 45452,
	"./uz-Cyrl/_lib/formatDistance": 84565,
	"./uz-Cyrl/_lib/formatDistance/": 84565,
	"./uz-Cyrl/_lib/formatDistance/index": 84565,
	"./uz-Cyrl/_lib/formatDistance/index.js": 84565,
	"./uz-Cyrl/_lib/formatLong": 53536,
	"./uz-Cyrl/_lib/formatLong/": 53536,
	"./uz-Cyrl/_lib/formatLong/index": 53536,
	"./uz-Cyrl/_lib/formatLong/index.js": 53536,
	"./uz-Cyrl/_lib/formatRelative": 10690,
	"./uz-Cyrl/_lib/formatRelative/": 10690,
	"./uz-Cyrl/_lib/formatRelative/index": 10690,
	"./uz-Cyrl/_lib/formatRelative/index.js": 10690,
	"./uz-Cyrl/_lib/localize": 21152,
	"./uz-Cyrl/_lib/localize/": 21152,
	"./uz-Cyrl/_lib/localize/index": 21152,
	"./uz-Cyrl/_lib/localize/index.js": 21152,
	"./uz-Cyrl/_lib/match": 50776,
	"./uz-Cyrl/_lib/match/": 50776,
	"./uz-Cyrl/_lib/match/index": 50776,
	"./uz-Cyrl/_lib/match/index.js": 50776,
	"./uz-Cyrl/index": 57675,
	"./uz-Cyrl/index.d.ts": 84171,
	"./uz-Cyrl/index.js": 57675,
	"./uz-Cyrl/index.js.flow": 47164,
	"./uz-Cyrl/package": 95622,
	"./uz-Cyrl/package.json": 95622,
	"./uz/": 91990,
	"./uz/_lib/formatDistance": 56903,
	"./uz/_lib/formatDistance/": 56903,
	"./uz/_lib/formatDistance/index": 56903,
	"./uz/_lib/formatDistance/index.js": 56903,
	"./uz/_lib/formatLong": 28946,
	"./uz/_lib/formatLong/": 28946,
	"./uz/_lib/formatLong/index": 28946,
	"./uz/_lib/formatLong/index.js": 28946,
	"./uz/_lib/formatRelative": 72360,
	"./uz/_lib/formatRelative/": 72360,
	"./uz/_lib/formatRelative/index": 72360,
	"./uz/_lib/formatRelative/index.js": 72360,
	"./uz/_lib/localize": 55858,
	"./uz/_lib/localize/": 55858,
	"./uz/_lib/localize/index": 55858,
	"./uz/_lib/localize/index.js": 55858,
	"./uz/_lib/match": 49428,
	"./uz/_lib/match/": 49428,
	"./uz/_lib/match/index": 49428,
	"./uz/_lib/match/index.js": 49428,
	"./uz/index": 97843,
	"./uz/index.d.ts": 58371,
	"./uz/index.js": 97843,
	"./uz/index.js.flow": 98789,
	"./uz/package": 881,
	"./uz/package.json": 881,
	"./vi": 31589,
	"./vi/": 31589,
	"./vi/_lib/formatDistance": 9923,
	"./vi/_lib/formatDistance/": 9923,
	"./vi/_lib/formatDistance/index": 9923,
	"./vi/_lib/formatDistance/index.js": 9923,
	"./vi/_lib/formatLong": 64147,
	"./vi/_lib/formatLong/": 64147,
	"./vi/_lib/formatLong/index": 64147,
	"./vi/_lib/formatLong/index.js": 64147,
	"./vi/_lib/formatRelative": 13744,
	"./vi/_lib/formatRelative/": 13744,
	"./vi/_lib/formatRelative/index": 13744,
	"./vi/_lib/formatRelative/index.js": 13744,
	"./vi/_lib/localize": 4217,
	"./vi/_lib/localize/": 4217,
	"./vi/_lib/localize/index": 4217,
	"./vi/_lib/localize/index.js": 4217,
	"./vi/_lib/match": 10333,
	"./vi/_lib/match/": 10333,
	"./vi/_lib/match/index": 10333,
	"./vi/_lib/match/index.js": 10333,
	"./vi/index": 81840,
	"./vi/index.d.ts": 67731,
	"./vi/index.js": 81840,
	"./vi/index.js.flow": 47989,
	"./vi/package": 51457,
	"./vi/package.json": 51457,
	"./zh-CN": 84961,
	"./zh-CN/": 84961,
	"./zh-CN/_lib/formatDistance": 91304,
	"./zh-CN/_lib/formatDistance/": 91304,
	"./zh-CN/_lib/formatDistance/index": 91304,
	"./zh-CN/_lib/formatDistance/index.js": 91304,
	"./zh-CN/_lib/formatLong": 77568,
	"./zh-CN/_lib/formatLong/": 77568,
	"./zh-CN/_lib/formatLong/index": 77568,
	"./zh-CN/_lib/formatLong/index.js": 77568,
	"./zh-CN/_lib/formatRelative": 18323,
	"./zh-CN/_lib/formatRelative/": 18323,
	"./zh-CN/_lib/formatRelative/index": 18323,
	"./zh-CN/_lib/formatRelative/index.js": 18323,
	"./zh-CN/_lib/localize": 50528,
	"./zh-CN/_lib/localize/": 50528,
	"./zh-CN/_lib/localize/index": 50528,
	"./zh-CN/_lib/localize/index.js": 50528,
	"./zh-CN/_lib/match": 69195,
	"./zh-CN/_lib/match/": 69195,
	"./zh-CN/_lib/match/index": 69195,
	"./zh-CN/_lib/match/index.js": 69195,
	"./zh-CN/index": 13540,
	"./zh-CN/index.d.ts": 6139,
	"./zh-CN/index.js": 13540,
	"./zh-CN/index.js.flow": 59962,
	"./zh-CN/package": 24183,
	"./zh-CN/package.json": 24183,
	"./zh-HK": 52339,
	"./zh-HK/": 52339,
	"./zh-HK/_lib/formatDistance": 67871,
	"./zh-HK/_lib/formatDistance/": 67871,
	"./zh-HK/_lib/formatDistance/index": 67871,
	"./zh-HK/_lib/formatDistance/index.js": 67871,
	"./zh-HK/_lib/formatLong": 27618,
	"./zh-HK/_lib/formatLong/": 27618,
	"./zh-HK/_lib/formatLong/index": 27618,
	"./zh-HK/_lib/formatLong/index.js": 27618,
	"./zh-HK/_lib/formatRelative": 95055,
	"./zh-HK/_lib/formatRelative/": 95055,
	"./zh-HK/_lib/formatRelative/index": 95055,
	"./zh-HK/_lib/formatRelative/index.js": 95055,
	"./zh-HK/_lib/localize": 23472,
	"./zh-HK/_lib/localize/": 23472,
	"./zh-HK/_lib/localize/index": 23472,
	"./zh-HK/_lib/localize/index.js": 23472,
	"./zh-HK/_lib/match": 26978,
	"./zh-HK/_lib/match/": 26978,
	"./zh-HK/_lib/match/index": 26978,
	"./zh-HK/_lib/match/index.js": 26978,
	"./zh-HK/index": 47124,
	"./zh-HK/index.d.ts": 34135,
	"./zh-HK/index.js": 47124,
	"./zh-HK/index.js.flow": 31038,
	"./zh-HK/package": 27518,
	"./zh-HK/package.json": 27518,
	"./zh-TW": 59876,
	"./zh-TW/": 59876,
	"./zh-TW/_lib/formatDistance": 76258,
	"./zh-TW/_lib/formatDistance/": 76258,
	"./zh-TW/_lib/formatDistance/index": 76258,
	"./zh-TW/_lib/formatDistance/index.js": 76258,
	"./zh-TW/_lib/formatLong": 13627,
	"./zh-TW/_lib/formatLong/": 13627,
	"./zh-TW/_lib/formatLong/index": 13627,
	"./zh-TW/_lib/formatLong/index.js": 13627,
	"./zh-TW/_lib/formatRelative": 58123,
	"./zh-TW/_lib/formatRelative/": 58123,
	"./zh-TW/_lib/formatRelative/index": 58123,
	"./zh-TW/_lib/formatRelative/index.js": 58123,
	"./zh-TW/_lib/localize": 60373,
	"./zh-TW/_lib/localize/": 60373,
	"./zh-TW/_lib/localize/index": 60373,
	"./zh-TW/_lib/localize/index.js": 60373,
	"./zh-TW/_lib/match": 49047,
	"./zh-TW/_lib/match/": 49047,
	"./zh-TW/_lib/match/index": 49047,
	"./zh-TW/_lib/match/index.js": 49047,
	"./zh-TW/index": 67292,
	"./zh-TW/index.d.ts": 26366,
	"./zh-TW/index.js": 67292,
	"./zh-TW/index.js.flow": 81530,
	"./zh-TW/package": 35907,
	"./zh-TW/package.json": 35907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16994;